msgid ""
msgstr ""
"POT-Creation-Date: 2025-06-21 23:16+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/share/components/layout/Layout/Layout.tsx:463
msgid "+ Add column"
msgstr "+ Add column"

#: src/share/components/gdpr/CookieConsent.tsx:41
msgid "Accept"
msgstr "Accept"

#: src/pages/ActivationPage.tsx:75
msgid "Access token is valid"
msgstr "Access token is valid"

#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx:37
#: src/timber/pages/accountingUser/AccountingUserEntityPage.tsx:17
msgid "Accounting User"
msgstr "Accounting User"

#: src/timber/hooks/useAccountingUser.ts:65
msgid "Accounting User add error: "
msgstr "Accounting User add error: "

#: src/timber/hooks/useAccountingUser.ts:131
msgid "Accounting User delete error: "
msgstr "Accounting User delete error: "

#: src/timber/hooks/useAccountingUser.ts:128
msgid "Accounting User deleted"
msgstr "Accounting User deleted"

#: src/timber/hooks/useAccountingUser.ts:98
msgid "Accounting User update error: "
msgstr "Accounting User update error: "

#: src/timber/hooks/useAccountingUser.ts:95
msgid "Accounting User updated"
msgstr "Accounting User updated"

#: src/app/mappers.tsx:222
#: src/auth/components/user/UserDetail/UserTabs.tsx:65
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListHeader.tsx:43
#: src/timber/pages/listItems.tsx:165
msgid "Accounting Users"
msgstr "Accounting Users"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:88
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx:184
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:289
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:450
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:91
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx:196
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryUpdateForm.tsx:60
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:291
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:452
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:82
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx:155
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:278
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:409
msgid "Action"
msgstr "Action"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx:141
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx:153
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryUpdateForm.tsx:43
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx:118
msgid "Action is required"
msgstr "Action is required"

#: src/pages/ActivationPage.tsx:126
#: src/pages/ActivationPage.tsx:160
msgid "Activate"
msgstr "Activate"

#: src/auth/components/user/UserDetail/UserDetail.tsx:65
#: src/auth/components/user/UserForm/UserAddForm.tsx:151
#: src/auth/components/user/UserForm/UserUpdateForm.tsx:92
#: src/auth/components/user/UserList/UserListItem.tsx:192
#: src/auth/components/user/UserList/UserListItem.tsx:312
msgid "Activated"
msgstr "Activated"

#: src/pages/ActivationPage.tsx:48
msgid "Activation"
msgstr "Activation"

#: src/pages/ActivationPage.tsx:40
msgid "Activation code is required"
msgstr "Activation code is required"

#: src/pages/ActivationPage.tsx:151
msgid "Activation Token"
msgstr "Activation Token"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx:131
msgid "Active cuttings"
msgstr "Active cuttings"

#: src/address/components/address/AddressForm/AddressAddFormProvider.tsx:68
#: src/address/components/address/AddressList/AddressListHeader.tsx:47
#: src/address/components/userAddress/UserAddressForm/UserAddressAddFormProvider.tsx:68
#: src/address/components/userAddress/UserAddressList/UserAddressListHeader.tsx:48
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddFormProvider.tsx:68
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListHeader.tsx:48
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddFormProvider.tsx:68
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListHeader.tsx:49
#: src/auth/components/role/RoleForm/RoleAddFormProvider.tsx:68
#: src/auth/components/role/RoleList/RoleListHeader.tsx:48
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddFormProvider.tsx:68
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListHeader.tsx:50
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddFormProvider.tsx:68
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListHeader.tsx:48
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddFormProvider.tsx:68
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListHeader.tsx:48
#: src/auth/components/user/UserForm/UserAddFormProvider.tsx:68
#: src/auth/components/user/UserList/UserListHeader.tsx:48
#: src/auth/components/userSession/UserSessionForm/UserSessionAddFormProvider.tsx:68
#: src/auth/components/userSession/UserSessionList/UserSessionListHeader.tsx:48
#: src/location/components/location/LocationForm/LocationAddFormProvider.tsx:68
#: src/location/components/location/LocationList/LocationListHeader.tsx:48
#: src/share/components/breadcrumbs/RouterBreadcrumbs.tsx:38
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddFormProvider.tsx:68
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListHeader.tsx:47
#: src/timber/components/buyer/BuyerForm/BuyerAddFormProvider.tsx:68
#: src/timber/components/buyer/BuyerList/BuyerListHeader.tsx:47
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddFormProvider.tsx:68
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListHeader.tsx:48
#: src/timber/components/contractor/ContractorForm/ContractorAddFormProvider.tsx:68
#: src/timber/components/contractor/ContractorList/ContractorListHeader.tsx:47
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddFormProvider.tsx:68
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListHeader.tsx:48
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddFormProvider.tsx:68
#: src/timber/components/cordwood/CordwoodList/CordwoodListHeader.tsx:59
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddFormProvider.tsx:68
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListHeader.tsx:48
#: src/timber/components/cutting/CuttingForm/CuttingAddFormProvider.tsx:68
#: src/timber/components/cutting/CuttingList/CuttingListHeader.tsx:49
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddFormProvider.tsx:68
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListHeader.tsx:47
#: src/timber/components/log/LogForm/LogAddFormProvider.tsx:68
#: src/timber/components/log/LogList/LogListHeader.tsx:59
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddFormProvider.tsx:68
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListHeader.tsx:48
#: src/timber/components/price/PriceForm/PriceAddFormProvider.tsx:68
#: src/timber/components/price/PriceList/PriceListHeader.tsx:48
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddFormProvider.tsx:68
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListHeader.tsx:47
#: src/timber/components/provider/ProviderForm/ProviderAddFormProvider.tsx:68
#: src/timber/components/provider/ProviderList/ProviderListHeader.tsx:47
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddFormProvider.tsx:68
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListHeader.tsx:48
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddFormProvider.tsx:68
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListHeader.tsx:47
#: src/timber/components/shipment/ShipmentForm/ShipmentAddFormProvider.tsx:80
#: src/timber/components/shipment/ShipmentList/ShipmentListHeader.tsx:59
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddFormProvider.tsx:68
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListHeader.tsx:48
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddFormProvider.tsx:68
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListHeader.tsx:47
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddFormProvider.tsx:68
#: src/timber/components/timberClass/TimberClassList/TimberClassListHeader.tsx:47
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddFormProvider.tsx:68
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListHeader.tsx:57
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddFormProvider.tsx:68
#: src/timber/components/timberType/TimberTypeList/TimberTypeListHeader.tsx:47
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddFormProvider.tsx:68
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListHeader.tsx:48
msgid "Add"
msgstr "Add"

#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserFormSelect.tsx:37
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserFormSelect.tsx:44
#: src/timber/pages/accountingUser/AccountingUserAddEditPage.tsx:13
#: src/timber/pages/accountingUser/AccountingUserAddEditPage.tsx:25
msgid "Add Accounting User"
msgstr "Add Accounting User"

#: src/address/components/address/AddressForm/AddressFormSelect.tsx:37
#: src/address/components/address/AddressForm/AddressFormSelect.tsx:44
#: src/address/pages/address/AddressAddEditPage.tsx:13
#: src/address/pages/address/AddressAddEditPage.tsx:25
msgid "Add Address"
msgstr "Add Address"

#: src/timber/components/buyer/BuyerForm/BuyerFormSelect.tsx:37
#: src/timber/components/buyer/BuyerForm/BuyerFormSelect.tsx:44
#: src/timber/pages/buyer/BuyerAddEditPage.tsx:13
#: src/timber/pages/buyer/BuyerAddEditPage.tsx:25
msgid "Add Buyer"
msgstr "Add Buyer"

#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserFormSelect.tsx:37
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserFormSelect.tsx:44
#: src/timber/pages/buyerUser/BuyerUserAddEditPage.tsx:13
#: src/timber/pages/buyerUser/BuyerUserAddEditPage.tsx:25
msgid "Add Buyer User"
msgstr "Add Buyer User"

#: src/timber/components/contractor/ContractorForm/ContractorFormSelect.tsx:37
#: src/timber/components/contractor/ContractorForm/ContractorFormSelect.tsx:44
#: src/timber/pages/contractor/ContractorAddEditPage.tsx:13
#: src/timber/pages/contractor/ContractorAddEditPage.tsx:25
msgid "Add Contractor"
msgstr "Add Contractor"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserFormSelect.tsx:37
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserFormSelect.tsx:44
#: src/timber/pages/contractorUser/ContractorUserAddEditPage.tsx:13
#: src/timber/pages/contractorUser/ContractorUserAddEditPage.tsx:25
msgid "Add Contractor User"
msgstr "Add Contractor User"

#: src/timber/components/cordwood/CordwoodForm/CordwoodFormSelect.tsx:37
#: src/timber/components/cordwood/CordwoodForm/CordwoodFormSelect.tsx:44
#: src/timber/pages/cordwood/CordwoodAddEditPage.tsx:13
#: src/timber/pages/cordwood/CordwoodAddEditPage.tsx:25
msgid "Add Cordwood"
msgstr "Add Cordwood"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryFormSelect.tsx:37
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryFormSelect.tsx:44
#: src/timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage.tsx:13
#: src/timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage.tsx:25
msgid "Add Cordwood History"
msgstr "Add Cordwood History"

#: src/timber/components/cutting/CuttingForm/CuttingFormSelect.tsx:37
#: src/timber/components/cutting/CuttingForm/CuttingFormSelect.tsx:44
#: src/timber/pages/cutting/CuttingAddEditPage.tsx:13
#: src/timber/pages/cutting/CuttingAddEditPage.tsx:25
msgid "Add Cutting"
msgstr "Add Cutting"

#: src/timber/pages/driver/DriverAddEditPage.tsx:24
#: src/timber/pages/driver/DriverAddEditPage.tsx:67
#~ msgid "Add Driver"
#~ msgstr "Add Driver"

#: src/address/hooks/useAddress.ts:56
#: src/address/hooks/useUserAddress.ts:51
#: src/auth/hooks/useMembersGroup.ts:56
#: src/auth/hooks/useMembersGroupUser.ts:51
#: src/auth/hooks/useRole.ts:56
#: src/auth/hooks/useRoleAssignment.ts:51
#: src/auth/hooks/useRolePermission.ts:51
#: src/auth/hooks/useScopeGroup.ts:56
#: src/auth/hooks/useUser.ts:56
#: src/auth/hooks/useUserSession.ts:56
#: src/location/hooks/useLocation.ts:56
#: src/timber/hooks/useAccountingUser.ts:56
#: src/timber/hooks/useBuyer.ts:56
#: src/timber/hooks/useBuyerUser.ts:56
#: src/timber/hooks/useContractor.ts:56
#: src/timber/hooks/useContractorUser.ts:56
#: src/timber/hooks/useCordwood.ts:56
#: src/timber/hooks/useCordwoodHistory.ts:51
#: src/timber/hooks/useCutting.ts:56
#: src/timber/hooks/useForestOwner.ts:56
#: src/timber/hooks/useLog.ts:56
#: src/timber/hooks/useLogHistory.ts:51
#: src/timber/hooks/usePrice.ts:56
#: src/timber/hooks/usePricingProfile.ts:56
#: src/timber/hooks/useProvider.ts:56
#: src/timber/hooks/useProviderUser.ts:56
#: src/timber/hooks/useRoadCarrier.ts:56
#: src/timber/hooks/useShipment.ts:56
#: src/timber/hooks/useShipmentHistory.ts:51
#: src/timber/hooks/useThicknessClass.ts:56
#: src/timber/hooks/useTimberClass.ts:56
#: src/timber/hooks/useTimberStorage.ts:56
#: src/timber/hooks/useTimberType.ts:56
#: src/timber/hooks/useTreeMarking.ts:56
msgid "Add error: "
msgstr "Add error: "

#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerFormSelect.tsx:37
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerFormSelect.tsx:44
#: src/timber/pages/forestOwner/ForestOwnerAddEditPage.tsx:13
#: src/timber/pages/forestOwner/ForestOwnerAddEditPage.tsx:25
msgid "Add Forest Owner"
msgstr "Add Forest Owner"

#: src/location/components/location/LocationForm/LocationFormSelect.tsx:37
#: src/location/components/location/LocationForm/LocationFormSelect.tsx:44
#: src/location/pages/location/LocationAddEditPage.tsx:13
#: src/location/pages/location/LocationAddEditPage.tsx:25
msgid "Add Location"
msgstr "Add Location"

#: src/timber/components/log/LogForm/LogFormSelect.tsx:37
#: src/timber/components/log/LogForm/LogFormSelect.tsx:44
#: src/timber/pages/log/LogAddEditPage.tsx:13
#: src/timber/pages/log/LogAddEditPage.tsx:25
msgid "Add Log"
msgstr "Add Log"

#: src/timber/components/logHistory/LogHistoryForm/LogHistoryFormSelect.tsx:37
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryFormSelect.tsx:44
#: src/timber/pages/logHistory/LogHistoryAddEditPage.tsx:13
#: src/timber/pages/logHistory/LogHistoryAddEditPage.tsx:25
msgid "Add Log History"
msgstr "Add Log History"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect.tsx:37
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect.tsx:44
#: src/auth/pages/membersGroup/MembersGroupAddEditPage.tsx:13
#: src/auth/pages/membersGroup/MembersGroupAddEditPage.tsx:25
msgid "Add Members Group"
msgstr "Add Members Group"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserFormSelect.tsx:37
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserFormSelect.tsx:44
#: src/auth/pages/membersGroupUser/MembersGroupUserAddEditPage.tsx:13
#: src/auth/pages/membersGroupUser/MembersGroupUserAddEditPage.tsx:25
msgid "Add Members Group User"
msgstr "Add Members Group User"

#: src/timber/components/price/PriceForm/PriceFormSelect.tsx:37
#: src/timber/components/price/PriceForm/PriceFormSelect.tsx:44
#: src/timber/pages/price/PriceAddEditPage.tsx:13
#: src/timber/pages/price/PriceAddEditPage.tsx:25
msgid "Add Price"
msgstr "Add Price"

#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileFormSelect.tsx:37
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileFormSelect.tsx:44
#: src/timber/pages/pricingProfile/PricingProfileAddEditPage.tsx:13
#: src/timber/pages/pricingProfile/PricingProfileAddEditPage.tsx:25
msgid "Add Pricing Profile"
msgstr "Add Pricing Profile"

#: src/timber/components/provider/ProviderForm/ProviderFormSelect.tsx:37
#: src/timber/components/provider/ProviderForm/ProviderFormSelect.tsx:44
#: src/timber/pages/provider/ProviderAddEditPage.tsx:13
#: src/timber/pages/provider/ProviderAddEditPage.tsx:25
msgid "Add Provider"
msgstr "Add Provider"

#: src/timber/components/providerUser/ProviderUserForm/ProviderUserFormSelect.tsx:37
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserFormSelect.tsx:44
#: src/timber/pages/providerUser/ProviderUserAddEditPage.tsx:13
#: src/timber/pages/providerUser/ProviderUserAddEditPage.tsx:25
msgid "Add Provider User"
msgstr "Add Provider User"

#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierFormSelect.tsx:37
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierFormSelect.tsx:44
#: src/timber/pages/roadCarrier/RoadCarrierAddEditPage.tsx:13
#: src/timber/pages/roadCarrier/RoadCarrierAddEditPage.tsx:25
msgid "Add Road Carrier"
msgstr "Add Road Carrier"

#: src/auth/components/role/RoleForm/RoleFormSelect.tsx:37
#: src/auth/components/role/RoleForm/RoleFormSelect.tsx:44
#: src/auth/pages/role/RoleAddEditPage.tsx:13
#: src/auth/pages/role/RoleAddEditPage.tsx:25
msgid "Add Role"
msgstr "Add Role"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentFormSelect.tsx:37
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentFormSelect.tsx:44
#: src/auth/pages/roleAssignment/RoleAssignmentAddEditPage.tsx:13
#: src/auth/pages/roleAssignment/RoleAssignmentAddEditPage.tsx:25
msgid "Add Role Assignment"
msgstr "Add Role Assignment"

#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionFormSelect.tsx:37
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionFormSelect.tsx:44
#: src/auth/pages/rolePermission/RolePermissionAddEditPage.tsx:13
#: src/auth/pages/rolePermission/RolePermissionAddEditPage.tsx:25
msgid "Add Role Permission"
msgstr "Add Role Permission"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupFormSelect.tsx:37
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupFormSelect.tsx:44
#: src/auth/pages/scopeGroup/ScopeGroupAddEditPage.tsx:13
#: src/auth/pages/scopeGroup/ScopeGroupAddEditPage.tsx:25
msgid "Add Scope Group"
msgstr "Add Scope Group"

#: src/timber/components/shipment/ShipmentForm/ShipmentFormSelect.tsx:37
#: src/timber/components/shipment/ShipmentForm/ShipmentFormSelect.tsx:44
#: src/timber/pages/shipment/ShipmentAddEditPage.tsx:13
#: src/timber/pages/shipment/ShipmentAddEditPage.tsx:25
msgid "Add Shipment"
msgstr "Add Shipment"

#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryFormSelect.tsx:37
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryFormSelect.tsx:44
#: src/timber/pages/shipmentHistory/ShipmentHistoryAddEditPage.tsx:13
#: src/timber/pages/shipmentHistory/ShipmentHistoryAddEditPage.tsx:25
msgid "Add Shipment History"
msgstr "Add Shipment History"

#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassFormSelect.tsx:37
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassFormSelect.tsx:44
#: src/timber/pages/thicknessClass/ThicknessClassAddEditPage.tsx:13
#: src/timber/pages/thicknessClass/ThicknessClassAddEditPage.tsx:25
msgid "Add Thickness Class"
msgstr "Add Thickness Class"

#: src/timber/components/timberClass/TimberClassForm/TimberClassFormSelect.tsx:37
#: src/timber/components/timberClass/TimberClassForm/TimberClassFormSelect.tsx:44
#: src/timber/pages/timberClass/TimberClassAddEditPage.tsx:13
#: src/timber/pages/timberClass/TimberClassAddEditPage.tsx:25
msgid "Add Timber Class"
msgstr "Add Timber Class"

#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageFormSelect.tsx:37
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageFormSelect.tsx:44
#: src/timber/pages/timberStorage/TimberStorageAddEditPage.tsx:13
#: src/timber/pages/timberStorage/TimberStorageAddEditPage.tsx:25
msgid "Add Timber Storage"
msgstr "Add Timber Storage"

#: src/timber/components/timberType/TimberTypeForm/TimberTypeFormSelect.tsx:37
#: src/timber/components/timberType/TimberTypeForm/TimberTypeFormSelect.tsx:44
#: src/timber/pages/timberType/TimberTypeAddEditPage.tsx:13
#: src/timber/pages/timberType/TimberTypeAddEditPage.tsx:25
msgid "Add Timber Type"
msgstr "Add Timber Type"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:150
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:72
msgid "Add to shipment"
msgstr "Add to shipment"

#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingFormSelect.tsx:37
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingFormSelect.tsx:44
#: src/timber/pages/treeMarking/TreeMarkingAddEditPage.tsx:13
#: src/timber/pages/treeMarking/TreeMarkingAddEditPage.tsx:25
msgid "Add Tree Marking"
msgstr "Add Tree Marking"

#: src/auth/components/user/UserForm/UserFormSelect.tsx:37
#: src/auth/components/user/UserForm/UserFormSelect.tsx:44
#: src/auth/pages/user/UserAddEditPage.tsx:13
#: src/auth/pages/user/UserAddEditPage.tsx:25
msgid "Add User"
msgstr "Add User"

#: src/address/components/userAddress/UserAddressForm/UserAddressFormSelect.tsx:37
#: src/address/components/userAddress/UserAddressForm/UserAddressFormSelect.tsx:44
#: src/address/pages/userAddress/UserAddressAddEditPage.tsx:13
#: src/address/pages/userAddress/UserAddressAddEditPage.tsx:25
msgid "Add User Address"
msgstr "Add User Address"

#: src/auth/components/userSession/UserSessionForm/UserSessionFormSelect.tsx:37
#: src/auth/components/userSession/UserSessionForm/UserSessionFormSelect.tsx:44
#: src/auth/pages/userSession/UserSessionAddEditPage.tsx:13
#: src/auth/pages/userSession/UserSessionAddEditPage.tsx:25
msgid "Add User Session"
msgstr "Add User Session"

#: src/address/components/address/AddressDetail/AddressDetail.tsx:32
#: src/address/components/address/AddressDetail/AddressDetail.tsx:58
#: src/address/components/address/AddressForm/AddressAddForm.tsx:157
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx:121
#: src/address/components/address/AddressList/AddressListItem.tsx:176
#: src/address/components/userAddress/UserAddressDetail/UserAddressDetail.tsx:69
#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx:108
#: src/address/components/userAddress/UserAddressList/UserAddressListItem.tsx:185
#: src/address/pages/address/AddressEntityPage.tsx:17
#: src/location/components/location/LocationDetail/LocationDetail.tsx:67
#: src/location/components/location/LocationForm/LocationAddForm.tsx:196
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx:140
#: src/location/components/location/LocationList/LocationListItem.tsx:256
#: src/location/components/location/LocationList/LocationListItem.tsx:335
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx:250
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx:210
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx:250
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx:210
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx:247
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx:210
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx:247
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx:210
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx:131
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx:106
msgid "Address"
msgstr "Address"

#: src/address/hooks/useAddress.ts:65
msgid "Address add error: "
msgstr "Address add error: "

#: src/address/hooks/useAddress.ts:131
msgid "Address delete error: "
msgstr "Address delete error: "

#: src/address/hooks/useAddress.ts:128
msgid "Address deleted"
msgstr "Address deleted"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx:55
#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx:56
#~ msgid "Address Id is required"
#~ msgstr "Address Id is required"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx:77
#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx:78
msgid "Address is required"
msgstr "Address is required"

#: src/address/hooks/useAddress.ts:98
msgid "Address update error: "
msgstr "Address update error: "

#: src/address/hooks/useAddress.ts:95
msgid "Address updated"
msgstr "Address updated"

#: src/address/components/address/AddressList/AddressListHeader.tsx:43
#: src/address/pages/listItems.tsx:42
#: src/app/mappers.tsx:195
msgid "Addresses"
msgstr "Addresses"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:915
msgid "Adjust prices to the target total amount"
msgstr "Adjust prices to the target total amount"

#: src/app/App.tsx:66
#: src/timber/types/models/UserType.d.ts:30
msgid "Admin"
msgstr "Admin"

#: src/address/components/address/AddressList/AddressListPagination.tsx:17
#: src/address/components/userAddress/UserAddressList/UserAddressListPagination.tsx:17
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListPagination.tsx:17
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListPagination.tsx:17
#: src/auth/components/role/RoleList/RoleListPagination.tsx:17
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListPagination.tsx:17
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListPagination.tsx:17
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListPagination.tsx:17
#: src/auth/components/user/UserList/UserListPagination.tsx:17
#: src/auth/components/userSession/UserSessionList/UserSessionListPagination.tsx:17
#: src/location/components/location/LocationList/LocationListPagination.tsx:17
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListPagination.tsx:17
#: src/timber/components/buyer/BuyerList/BuyerListPagination.tsx:17
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListPagination.tsx:17
#: src/timber/components/contractor/ContractorList/ContractorListPagination.tsx:17
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListPagination.tsx:17
#: src/timber/components/cordwood/CordwoodList/CordwoodListPagination.tsx:17
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListPagination.tsx:17
#: src/timber/components/cutting/CuttingList/CuttingListPagination.tsx:17
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListPagination.tsx:17
#: src/timber/components/generic/report/GenericRootShipments.tsx:544
#: src/timber/components/log/LogList/LogListPagination.tsx:17
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListPagination.tsx:17
#: src/timber/components/price/PriceList/PriceListPagination.tsx:17
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListPagination.tsx:17
#: src/timber/components/provider/ProviderList/ProviderListPagination.tsx:17
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListPagination.tsx:17
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListPagination.tsx:17
#: src/timber/components/shipment/ShipmentList/ShipmentListPagination.tsx:17
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListPagination.tsx:17
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListPagination.tsx:17
#: src/timber/components/timberClass/TimberClassList/TimberClassListPagination.tsx:17
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListPagination.tsx:17
#: src/timber/components/timberType/TimberTypeList/TimberTypeListPagination.tsx:17
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListPagination.tsx:17
#~ msgid "All"
#~ msgstr "All"

#: src/pages/LoginPage.tsx:226
msgid "and"
msgstr "and"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:193
msgid "Apply"
msgstr "Apply"

#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx:80
msgid "Assign"
msgstr "Assign"

#: src/timber/components/generic/report/GenericRootShipments.tsx:320
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:425
msgid "at"
msgstr "at"

#: src/auth/pages/listItems.tsx:94
msgid "Auth"
msgstr "Auth"

#: src/address/pages/address/AddressAddEditPage.tsx:84
#: src/address/pages/address/AddressDetailPage.tsx:41
#: src/address/pages/address/AddressUpdateEditPage.tsx:80
#: src/address/pages/userAddress/UserAddressAddEditPage.tsx:76
#: src/address/pages/userAddress/UserAddressDetailPage.tsx:41
#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx:73
#: src/auth/pages/membersGroup/MembersGroupAddEditPage.tsx:82
#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx:41
#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx:80
#: src/auth/pages/membersGroupUser/MembersGroupUserAddEditPage.tsx:78
#: src/auth/pages/membersGroupUser/MembersGroupUserDetailPage.tsx:41
#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx:73
#: src/auth/pages/role/RoleAddEditPage.tsx:80
#: src/auth/pages/role/RoleDetailPage.tsx:41
#: src/auth/pages/role/RoleUpdateEditPage.tsx:80
#: src/auth/pages/roleAssignment/RoleAssignmentAddEditPage.tsx:84
#: src/auth/pages/roleAssignment/RoleAssignmentDetailPage.tsx:41
#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx:73
#: src/auth/pages/rolePermission/RolePermissionAddEditPage.tsx:78
#: src/auth/pages/rolePermission/RolePermissionDetailPage.tsx:41
#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx:73
#: src/auth/pages/scopeGroup/ScopeGroupAddEditPage.tsx:86
#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx:51
#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx:80
#: src/auth/pages/user/UserAddEditPage.tsx:84
#: src/auth/pages/user/UserDetailPage.tsx:41
#: src/auth/pages/user/UserUpdateEditPage.tsx:80
#: src/auth/pages/userSession/UserSessionAddEditPage.tsx:84
#: src/auth/pages/userSession/UserSessionDetailPage.tsx:41
#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx:80
#: src/location/pages/location/LocationAddEditPage.tsx:90
#: src/location/pages/location/LocationDetailPage.tsx:41
#: src/location/pages/location/LocationUpdateEditPage.tsx:80
#: src/timber/pages/accountingUser/AccountingUserAddEditPage.tsx:80
#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx:41
#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx:80
#: src/timber/pages/buyer/BuyerAddEditPage.tsx:88
#: src/timber/pages/buyer/BuyerDetailPage.tsx:41
#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx:80
#: src/timber/pages/buyerUser/BuyerUserAddEditPage.tsx:86
#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx:41
#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx:80
#: src/timber/pages/contractor/ContractorAddEditPage.tsx:88
#: src/timber/pages/contractor/ContractorDetailPage.tsx:41
#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx:80
#: src/timber/pages/contractorUser/ContractorUserAddEditPage.tsx:98
#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx:41
#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx:80
#: src/timber/pages/cordwood/CordwoodAddEditPage.tsx:104
#: src/timber/pages/cordwood/CordwoodDetailPage.tsx:41
#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx:80
#: src/timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage.tsx:104
#: src/timber/pages/cordwoodHistory/CordwoodHistoryDetailPage.tsx:41
#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx:73
#: src/timber/pages/cutting/CuttingAddEditPage.tsx:96
#: src/timber/pages/cutting/CuttingDetailPage.tsx:44
#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx:80
#: src/timber/pages/forestOwner/ForestOwnerAddEditPage.tsx:86
#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx:41
#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx:80
#: src/timber/pages/log/LogAddEditPage.tsx:116
#: src/timber/pages/log/LogDetailPage.tsx:41
#: src/timber/pages/log/LogUpdateEditPage.tsx:80
#: src/timber/pages/logHistory/LogHistoryAddEditPage.tsx:114
#: src/timber/pages/logHistory/LogHistoryDetailPage.tsx:41
#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx:73
#: src/timber/pages/price/PriceAddEditPage.tsx:84
#: src/timber/pages/price/PriceDetailPage.tsx:41
#: src/timber/pages/price/PriceUpdateEditPage.tsx:80
#: src/timber/pages/pricingProfile/PricingProfileAddEditPage.tsx:76
#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx:41
#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx:80
#: src/timber/pages/provider/ProviderAddEditPage.tsx:86
#: src/timber/pages/provider/ProviderDetailPage.tsx:41
#: src/timber/pages/provider/ProviderUpdateEditPage.tsx:80
#: src/timber/pages/providerUser/ProviderUserAddEditPage.tsx:88
#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx:41
#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx:80
#: src/timber/pages/roadCarrier/RoadCarrierAddEditPage.tsx:78
#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx:41
#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx:80
#: src/timber/pages/shipment/ShipmentAddEditPage.tsx:141
#: src/timber/pages/shipment/ShipmentDetailPage.tsx:48
#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx:80
#: src/timber/pages/shipmentHistory/ShipmentHistoryAddEditPage.tsx:94
#: src/timber/pages/shipmentHistory/ShipmentHistoryDetailPage.tsx:41
#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx:73
#: src/timber/pages/thicknessClass/ThicknessClassAddEditPage.tsx:86
#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx:41
#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx:80
#: src/timber/pages/timberClass/TimberClassAddEditPage.tsx:80
#: src/timber/pages/timberClass/TimberClassDetailPage.tsx:41
#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx:80
#: src/timber/pages/timberStorage/TimberStorageAddEditPage.tsx:84
#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx:48
#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx:80
#: src/timber/pages/timberType/TimberTypeAddEditPage.tsx:80
#: src/timber/pages/timberType/TimberTypeDetailPage.tsx:41
#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx:80
#: src/timber/pages/treeMarking/TreeMarkingAddEditPage.tsx:82
#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx:41
#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx:80
#~ msgid "Back"
#~ msgstr "Back"

#: src/pages/ForgotPasswordPage.tsx:199
msgid "Back to Login"
msgstr "Back to Login"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx:77
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx:224
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx:184
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx:77
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx:224
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx:184
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx:77
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx:221
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx:184
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx:77
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx:221
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx:184
msgid "Bank"
msgstr "Bank"

#: src/auth/components/user/UserDetail/UserDetail.tsx:68
#: src/auth/components/user/UserForm/UserAddForm.tsx:164
#: src/auth/components/user/UserForm/UserUpdateForm.tsx:105
#: src/auth/components/user/UserList/UserListItem.tsx:329
msgid "Banned"
msgstr "Banned"

#: src/timber/components/log/LogDetail/LogDetail.tsx:114
#: src/timber/components/log/LogForm/LogAddForm.tsx:425
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:297
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:149
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:97
msgid "Bark Thickness"
msgstr "Bark Thickness"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx:39
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx:76
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx:176
#: src/timber/components/generic/report/GenericRootShipments.tsx:219
#: src/timber/components/generic/report/GenericRootShipments.tsx:417
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:110
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:521
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:329
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:268
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:618
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:360
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:103
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:503
#: src/timber/pages/buyer/BuyerEntityPage.tsx:17
#: src/timber/pages/listItems.tsx:86
msgid "Buyer"
msgstr "Buyer"

#: src/timber/hooks/useBuyer.ts:65
msgid "Buyer add error: "
msgstr "Buyer add error: "

#: src/timber/hooks/useBuyer.ts:131
msgid "Buyer delete error: "
msgstr "Buyer delete error: "

#: src/timber/hooks/useBuyer.ts:128
msgid "Buyer deleted"
msgstr "Buyer deleted"

#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx:89
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx:90
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:234
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:152
#~ msgid "Buyer Id is required"
#~ msgstr "Buyer Id is required"

#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx:114
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx:115
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:317
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:401
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:163
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:241
msgid "Buyer is required"
msgstr "Buyer is required"

#: src/timber/hooks/useBuyer.ts:98
msgid "Buyer update error: "
msgstr "Buyer update error: "

#: src/timber/hooks/useBuyer.ts:95
msgid "Buyer updated"
msgstr "Buyer updated"

#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx:40
#: src/timber/pages/buyerUser/BuyerUserEntityPage.tsx:17
msgid "Buyer User"
msgstr "Buyer User"

#: src/timber/hooks/useBuyerUser.ts:65
msgid "Buyer User add error: "
msgstr "Buyer User add error: "

#: src/timber/hooks/useBuyerUser.ts:131
msgid "Buyer User delete error: "
msgstr "Buyer User delete error: "

#: src/timber/hooks/useBuyerUser.ts:128
msgid "Buyer User deleted"
msgstr "Buyer User deleted"

#: src/timber/hooks/useBuyerUser.ts:98
msgid "Buyer User update error: "
msgstr "Buyer User update error: "

#: src/timber/hooks/useBuyerUser.ts:95
msgid "Buyer User updated"
msgstr "Buyer User updated"

#: src/app/mappers.tsx:215
#: src/auth/components/user/UserDetail/UserTabs.tsx:53
#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx:61
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListHeader.tsx:44
msgid "Buyer Users"
msgstr "Buyer Users"

#: src/app/mappers.tsx:214
#: src/timber/components/buyer/BuyerList/BuyerListHeader.tsx:43
#: src/timber/pages/listItems.tsx:76
msgid "Buyers"
msgstr "Buyers"

#: src/pages/LoginPage.tsx:226
msgid "By logging in you agree to our"
msgstr "By logging in you agree to our"

#: src/pages/TermsPage.tsx:14
msgid "By using this application, you agree to use it in accordance with applicable laws and our policies. You are responsible for maintaining the security of your account."
msgstr "By using this application, you agree to use it in accordance with applicable laws and our policies. You are responsible for maintaining the security of your account."

#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:466
#: src/timber/components/log/LogList/LogListItem.tsx:511
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:480
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:155
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:494
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:190
msgid "C"
msgstr "C"

#: src/address/components/address/AddressForm/AddressFormSelect.tsx:54
#: src/address/components/userAddress/UserAddressForm/UserAddressFormSelect.tsx:54
#: src/address/pages/address/AddressAddEditPage.tsx:35
#: src/address/pages/address/AddressUpdateEditPage.tsx:39
#: src/address/pages/userAddress/UserAddressAddEditPage.tsx:35
#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx:39
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect.tsx:54
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx:343
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserFormSelect.tsx:54
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx:331
#: src/auth/components/role/RoleForm/RoleFormSelect.tsx:54
#: src/auth/components/role/RoleList/RoleListSearch.tsx:327
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentFormSelect.tsx:54
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx:394
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionFormSelect.tsx:54
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx:276
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupFormSelect.tsx:54
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx:320
#: src/auth/components/user/UserForm/UserFormSelect.tsx:54
#: src/auth/components/userSession/UserSessionForm/UserSessionFormSelect.tsx:54
#: src/auth/pages/membersGroup/MembersGroupAddEditPage.tsx:35
#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx:39
#: src/auth/pages/membersGroupUser/MembersGroupUserAddEditPage.tsx:35
#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx:39
#: src/auth/pages/role/RoleAddEditPage.tsx:35
#: src/auth/pages/role/RoleUpdateEditPage.tsx:39
#: src/auth/pages/roleAssignment/RoleAssignmentAddEditPage.tsx:35
#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx:39
#: src/auth/pages/rolePermission/RolePermissionAddEditPage.tsx:35
#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx:39
#: src/auth/pages/scopeGroup/ScopeGroupAddEditPage.tsx:35
#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx:39
#: src/auth/pages/user/UserAddEditPage.tsx:35
#: src/auth/pages/user/UserUpdateEditPage.tsx:39
#: src/auth/pages/userSession/UserSessionAddEditPage.tsx:35
#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx:39
#: src/location/components/location/LocationForm/LocationFormSelect.tsx:54
#: src/location/components/location/LocationList/LocationListSearch.tsx:319
#: src/location/pages/location/LocationAddEditPage.tsx:35
#: src/location/pages/location/LocationUpdateEditPage.tsx:39
#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx:28
#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx:27
#: src/share/components/form/FormDateTime/FormDate.tsx:65
#: src/share/components/form/FormDateTime/FormDateTime.tsx:66
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserFormSelect.tsx:54
#: src/timber/components/buyer/BuyerForm/BuyerFormSelect.tsx:54
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserFormSelect.tsx:54
#: src/timber/components/contractor/ContractorForm/ContractorFormSelect.tsx:54
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserFormSelect.tsx:54
#: src/timber/components/cordwood/CordwoodForm/CordwoodFormSelect.tsx:54
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:512
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryFormSelect.tsx:54
#: src/timber/components/cutting/CuttingForm/CuttingFormSelect.tsx:54
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx:334
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerFormSelect.tsx:54
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:951
#: src/timber/components/log/LogForm/LogFormSelect.tsx:54
#: src/timber/components/log/LogList/LogListSearch.tsx:625
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryFormSelect.tsx:54
#: src/timber/components/price/PriceForm/PriceFormSelect.tsx:54
#: src/timber/components/price/PriceList/PriceListSearch.tsx:332
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileFormSelect.tsx:54
#: src/timber/components/provider/ProviderForm/ProviderFormSelect.tsx:54
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserFormSelect.tsx:54
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierFormSelect.tsx:54
#: src/timber/components/shipment/ShipmentForm/ShipmentFormSelect.tsx:54
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:457
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryFormSelect.tsx:54
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassFormSelect.tsx:54
#: src/timber/components/timberClass/TimberClassForm/TimberClassFormSelect.tsx:54
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageFormSelect.tsx:54
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx:285
#: src/timber/components/timberType/TimberTypeForm/TimberTypeFormSelect.tsx:54
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingFormSelect.tsx:54
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx:349
#: src/timber/pages/accountingUser/AccountingUserAddEditPage.tsx:35
#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx:39
#: src/timber/pages/buyer/BuyerAddEditPage.tsx:35
#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx:39
#: src/timber/pages/buyerUser/BuyerUserAddEditPage.tsx:35
#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx:39
#: src/timber/pages/contractor/ContractorAddEditPage.tsx:35
#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx:39
#: src/timber/pages/contractorUser/ContractorUserAddEditPage.tsx:35
#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx:39
#: src/timber/pages/cordwood/CordwoodAddEditPage.tsx:35
#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx:39
#: src/timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage.tsx:35
#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx:39
#: src/timber/pages/cutting/CuttingAddEditPage.tsx:35
#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx:39
#: src/timber/pages/forestOwner/ForestOwnerAddEditPage.tsx:35
#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx:39
#: src/timber/pages/log/LogAddEditPage.tsx:35
#: src/timber/pages/log/LogUpdateEditPage.tsx:39
#: src/timber/pages/logHistory/LogHistoryAddEditPage.tsx:35
#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx:39
#: src/timber/pages/price/PriceAddEditPage.tsx:35
#: src/timber/pages/price/PriceUpdateEditPage.tsx:39
#: src/timber/pages/pricingProfile/PricingProfileAddEditPage.tsx:35
#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx:39
#: src/timber/pages/provider/ProviderAddEditPage.tsx:35
#: src/timber/pages/provider/ProviderUpdateEditPage.tsx:39
#: src/timber/pages/providerUser/ProviderUserAddEditPage.tsx:35
#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx:39
#: src/timber/pages/roadCarrier/RoadCarrierAddEditPage.tsx:35
#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx:39
#: src/timber/pages/shipment/ShipmentAddEditPage.tsx:35
#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx:39
#: src/timber/pages/shipmentHistory/ShipmentHistoryAddEditPage.tsx:35
#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx:39
#: src/timber/pages/thicknessClass/ThicknessClassAddEditPage.tsx:35
#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx:39
#: src/timber/pages/timberClass/TimberClassAddEditPage.tsx:35
#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx:39
#: src/timber/pages/timberStorage/TimberStorageAddEditPage.tsx:35
#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx:39
#: src/timber/pages/timberType/TimberTypeAddEditPage.tsx:35
#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx:39
#: src/timber/pages/treeMarking/TreeMarkingAddEditPage.tsx:35
#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx:39
msgid "Cancel"
msgstr "Cancel"

#: src/timber/types/models/ShipmentState.d.ts:36
msgid "Cancelled"
msgstr "Cancelled"

#: src/app/App.tsx:118
#: src/pages/ChangePasswordPage.tsx:59
#: src/pages/ChangePasswordPage.tsx:127
#: src/pages/ChangePasswordPage.tsx:168
msgid "Change Password"
msgstr "Change Password"

#: src/address/components/address/AddressDetail/AddressDetail.tsx:61
#: src/address/components/address/AddressForm/AddressAddForm.tsx:172
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx:136
#: src/address/components/address/AddressList/AddressListItem.tsx:250
#: src/location/components/location/LocationDetail/LocationDetail.tsx:70
#: src/location/components/location/LocationForm/LocationAddForm.tsx:211
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx:155
#: src/location/components/location/LocationList/LocationListItem.tsx:273
#: src/location/components/location/LocationList/LocationListItem.tsx:352
msgid "City"
msgstr "City"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:734
#: src/timber/components/generic/report/GenericRootTable.tsx:127
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:97
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:406
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:98
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:109
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:389
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:101
msgid "Class"
msgstr "Class"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:159
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:160
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:101
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:102
#: src/timber/components/log/LogForm/LogAddForm.tsx:201
#: src/timber/components/log/LogForm/LogAddForm.tsx:202
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:131
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:132
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:98
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:99
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:67
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:68
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:122
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:104
#~ msgid "Class Id is required"
#~ msgstr "Class Id is required"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:194
#: src/timber/components/generic/report/GenericRootReportPdfDialog.tsx:111
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListPdfDialog.tsx:180
#: src/timber/components/shipment/ShipmentRegulator/CordwoodShipmentReportPdfDialog.tsx:87
#: src/timber/components/shipment/ShipmentRegulator/LogListPdfDialog.tsx:172
#: src/timber/components/shipment/ShipmentRegulator/LogShipmentReportPdfDialog.tsx:87
msgid "Close"
msgstr "Close"

#: src/timber/types/models/CuttingState.d.ts:33
#: src/timber/types/models/ShipmentState.d.ts:33
msgid "Closed"
msgstr "Closed"

#: src/share/components/layout/Layout/Layout.tsx:259
#: src/share/components/layout/Layout/Layout.tsx:511
msgid "Column"
msgstr "Column"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:378
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:394
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:359
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:375
msgid "Commit"
msgstr "Commit"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:104
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:366
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:250
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:656
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:136
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:362
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:685
#: src/timber/components/log/LogDetail/LogDetail.tsx:120
#: src/timber/components/log/LogForm/LogAddForm.tsx:458
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:330
#: src/timber/components/log/LogList/LogListItem.tsx:771
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:152
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:364
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:744
msgid "Commited"
msgstr "Commited"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:315
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:296
msgid "Commited / Total"
msgstr "Commited / Total"

#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx:29
msgid "Confirm"
msgstr "Confirm"

#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx:21
msgid "Confirm Delete"
msgstr "Confirm Delete"

#: src/pages/ChangePasswordPage.tsx:156
msgid "Confirm New Password"
msgstr "Confirm New Password"

#: src/pages/ResetPasswordPage.tsx:154
#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx:20
msgid "Confirm Password"
msgstr "Confirm Password"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:91
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx:199
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:467
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:94
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx:211
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:469
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:85
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx:170
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:426
msgid "Context History"
msgstr "Context History"

#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx:39
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx:91
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:322
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx:99
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:311
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx:392
#: src/timber/pages/contractor/ContractorEntityPage.tsx:17
#: src/timber/pages/listItems.tsx:122
msgid "Contractor"
msgstr "Contractor"

#: src/timber/hooks/useContractor.ts:65
msgid "Contractor add error: "
msgstr "Contractor add error: "

#: src/timber/hooks/useContractor.ts:131
msgid "Contractor delete error: "
msgstr "Contractor delete error: "

#: src/timber/hooks/useContractor.ts:128
msgid "Contractor deleted"
msgstr "Contractor deleted"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:157
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:158
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:160
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:161
#~ msgid "Contractor Id is required"
#~ msgstr "Contractor Id is required"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:187
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:188
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:191
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:192
msgid "Contractor is required"
msgstr "Contractor is required"

#: src/timber/hooks/useContractor.ts:98
msgid "Contractor update error: "
msgstr "Contractor update error: "

#: src/timber/hooks/useContractor.ts:95
msgid "Contractor updated"
msgstr "Contractor updated"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx:40
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:99
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:419
#: src/timber/pages/contractorUser/ContractorUserEntityPage.tsx:17
msgid "Contractor User"
msgstr "Contractor User"

#: src/timber/hooks/useContractorUser.ts:65
msgid "Contractor User add error: "
msgstr "Contractor User add error: "

#: src/timber/hooks/useContractorUser.ts:131
msgid "Contractor User delete error: "
msgstr "Contractor User delete error: "

#: src/timber/hooks/useContractorUser.ts:128
msgid "Contractor User deleted"
msgstr "Contractor User deleted"

#: src/timber/hooks/useContractorUser.ts:98
msgid "Contractor User update error: "
msgstr "Contractor User update error: "

#: src/timber/hooks/useContractorUser.ts:95
msgid "Contractor User updated"
msgstr "Contractor User updated"

#: src/app/mappers.tsx:218
#: src/auth/components/user/UserDetail/UserTabs.tsx:59
#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx:82
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListHeader.tsx:44
msgid "Contractor Users"
msgstr "Contractor Users"

#: src/app/mappers.tsx:217
#: src/timber/components/contractor/ContractorList/ContractorListHeader.tsx:43
#: src/timber/pages/listItems.tsx:110
msgid "Contractors"
msgstr "Contractors"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:55
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:85
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx:169
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:195
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:432
#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx:157
#: src/timber/components/generic/report/StorageShipmentPies.tsx:151
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:402
#: src/timber/pages/cordwood/CordwoodEntityPage.tsx:17
#: src/timber/types/models/ShipmentType.d.ts:27
msgid "Cordwood"
msgstr "Cordwood"

#: src/timber/hooks/useCordwood.ts:65
msgid "Cordwood add error: "
msgstr "Cordwood add error: "

#: src/timber/hooks/useCordwood.ts:131
msgid "Cordwood delete error: "
msgstr "Cordwood delete error: "

#: src/timber/hooks/useCordwood.ts:128
msgid "Cordwood deleted"
msgstr "Cordwood deleted"

#: src/app/mappers.tsx:230
#: src/timber/components/cordwood/CordwoodDetail/CordwoodTabs.tsx:41
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListHeader.tsx:44
msgid "Cordwood Histories"
msgstr "Cordwood Histories"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:58
#: src/timber/pages/cordwoodHistory/CordwoodHistoryEntityPage.tsx:17
msgid "Cordwood History"
msgstr "Cordwood History"

#: src/timber/hooks/useCordwoodHistory.ts:60
msgid "Cordwood History add error: "
msgstr "Cordwood History add error: "

#: src/timber/hooks/useCordwoodHistory.ts:95
msgid "Cordwood History delete error: "
msgstr "Cordwood History delete error: "

#: src/timber/hooks/useCordwoodHistory.ts:92
msgid "Cordwood History deleted"
msgstr "Cordwood History deleted"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx:98
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx:99
#~ msgid "Cordwood Id is required"
#~ msgstr "Cordwood Id is required"

#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx:134
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx:135
msgid "Cordwood is required"
msgstr "Cordwood is required"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItem.tsx:216
#~ msgid "Cordwood Key"
#~ msgstr "Cordwood Key"

#: src/timber/components/generic/report/GenericRootReport.tsx:401
msgid "Cordwood Shipments"
msgstr "Cordwood Shipments"

#: src/timber/hooks/useCordwood.ts:98
msgid "Cordwood update error: "
msgstr "Cordwood update error: "

#: src/timber/hooks/useCordwood.ts:95
msgid "Cordwood updated"
msgstr "Cordwood updated"

#: src/app/mappers.tsx:227
#: src/timber/components/cordwood/CordwoodList/CordwoodListHeader.tsx:53
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:69
#: src/timber/components/generic/report/GenericRootShipments.tsx:117
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx:84
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx:66
msgid "Cordwoods"
msgstr "Cordwoods"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:473
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:320
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:301
msgid "Count"
msgstr "Count"

#: src/address/components/address/AddressDetail/AddressDetail.tsx:64
#: src/address/components/address/AddressForm/AddressAddForm.tsx:187
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx:151
#: src/location/components/location/LocationDetail/LocationDetail.tsx:73
#: src/location/components/location/LocationForm/LocationAddForm.tsx:226
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx:170
#: src/location/components/location/LocationList/LocationListItem.tsx:369
msgid "Country"
msgstr "Country"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:931
msgid "Create new pricing profile"
msgstr "Create new pricing profile"

#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx:80
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx:202
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx:380
#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx:69
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx:239
#: src/auth/components/user/UserDetail/UserDetail.tsx:71
#: src/auth/components/user/UserList/UserListItem.tsx:346
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx:76
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx:193
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx:344
#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:123
#: src/timber/components/log/LogDetail/LogDetail.tsx:139
msgid "Created At"
msgstr "Created At"

#: src/timber/components/generic/report/TimelineRootReport.tsx:334
#~ msgid "Created At From"
#~ msgstr "Created At From"

#: src/timber/components/generic/report/TimelineRootReport.tsx:335
#~ msgid "Created At To"
#~ msgstr "Created At To"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:116
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:112
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx:49
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:554
#: src/timber/components/generic/report/GenericRootReport.tsx:256
#: src/timber/components/generic/report/GenericRootShipments.tsx:279
#: src/timber/components/generic/report/TimelineRootReport.tsx:323
#: src/timber/components/log/LogDetail/LogDetail.tsx:132
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:118
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:88
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:373
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:99
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx:76
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:157
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx:73
#: src/timber/pages/cutting/CuttingEntityPage.tsx:17
msgid "Cutting"
msgstr "Cutting"

#: src/timber/hooks/useCutting.ts:65
msgid "Cutting add error: "
msgstr "Cutting add error: "

#: src/timber/hooks/useCutting.ts:131
msgid "Cutting delete error: "
msgstr "Cutting delete error: "

#: src/timber/hooks/useCutting.ts:128
msgid "Cutting deleted"
msgstr "Cutting deleted"

#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:80
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:81
#~ msgid "Cutting Id is required"
#~ msgstr "Cutting Id is required"

#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:113
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:114
msgid "Cutting is required"
msgstr "Cutting is required"

#: src/timber/hooks/useCutting.ts:98
msgid "Cutting update error: "
msgstr "Cutting update error: "

#: src/timber/hooks/useCutting.ts:95
msgid "Cutting updated"
msgstr "Cutting updated"

#: src/app/mappers.tsx:223
#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx:85
#: src/timber/components/cutting/CuttingList/CuttingListHeader.tsx:45
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx:58
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx:45
#: src/timber/pages/listItems.tsx:178
msgid "Cuttings"
msgstr "Cuttings"

#: src/pages/PreferencesPage.tsx:91
msgid "Dark"
msgstr "Dark"

#: src/app/App.tsx:60
#: src/app/mappers.tsx:194
#: src/pages/listItems.tsx:20
msgid "Dashboard"
msgstr "Dashboard"

#: src/timber/components/generic/report/GenericRootReport.tsx:398
msgid "Data"
msgstr "Data"

#: src/timber/components/generic/report/TimelineRootReport.tsx:442
#: src/timber/components/generic/report/TimelineRootReport.tsx:470
#: src/timber/components/generic/report/TimelineRootReport.tsx:511
msgid "Date"
msgstr "Date"

#: src/share/components/gdpr/CookieConsent.tsx:39
msgid "Decline"
msgstr "Decline"

#: src/address/pages/address/AddressDetailPage.tsx:63
#: src/address/pages/address/AddressEntityPage.tsx:57
#: src/address/pages/userAddress/UserAddressDetailPage.tsx:46
#: src/address/pages/userAddress/UserAddressEntityPage.tsx:40
#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx:57
#: src/auth/pages/membersGroup/MembersGroupEntityPage.tsx:51
#: src/auth/pages/membersGroupUser/MembersGroupUserDetailPage.tsx:46
#: src/auth/pages/membersGroupUser/MembersGroupUserEntityPage.tsx:40
#: src/auth/pages/role/RoleDetailPage.tsx:57
#: src/auth/pages/role/RoleEntityPage.tsx:51
#: src/auth/pages/roleAssignment/RoleAssignmentDetailPage.tsx:46
#: src/auth/pages/roleAssignment/RoleAssignmentEntityPage.tsx:40
#: src/auth/pages/rolePermission/RolePermissionDetailPage.tsx:46
#: src/auth/pages/rolePermission/RolePermissionEntityPage.tsx:40
#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx:87
#: src/auth/pages/scopeGroup/ScopeGroupEntityPage.tsx:51
#: src/auth/pages/user/UserDetailPage.tsx:57
#: src/auth/pages/user/UserEntityPage.tsx:51
#: src/auth/pages/userSession/UserSessionDetailPage.tsx:57
#: src/auth/pages/userSession/UserSessionEntityPage.tsx:51
#: src/location/pages/location/LocationDetailPage.tsx:63
#: src/location/pages/location/LocationEntityPage.tsx:57
#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx:63
#: src/timber/pages/accountingUser/AccountingUserEntityPage.tsx:57
#: src/timber/pages/buyer/BuyerDetailPage.tsx:71
#: src/timber/pages/buyer/BuyerEntityPage.tsx:65
#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx:71
#: src/timber/pages/buyerUser/BuyerUserEntityPage.tsx:65
#: src/timber/pages/contractor/ContractorDetailPage.tsx:71
#: src/timber/pages/contractor/ContractorEntityPage.tsx:65
#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx:79
#: src/timber/pages/contractorUser/ContractorUserEntityPage.tsx:73
#: src/timber/pages/cordwood/CordwoodDetailPage.tsx:67
#: src/timber/pages/cordwood/CordwoodEntityPage.tsx:57
#: src/timber/pages/cordwoodHistory/CordwoodHistoryDetailPage.tsx:49
#: src/timber/pages/cordwoodHistory/CordwoodHistoryEntityPage.tsx:43
#: src/timber/pages/cutting/CuttingDetailPage.tsx:80
#: src/timber/pages/cutting/CuttingEntityPage.tsx:65
#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx:63
#: src/timber/pages/forestOwner/ForestOwnerEntityPage.tsx:57
#: src/timber/pages/log/LogDetailPage.tsx:67
#: src/timber/pages/log/LogEntityPage.tsx:57
#: src/timber/pages/logHistory/LogHistoryDetailPage.tsx:49
#: src/timber/pages/logHistory/LogHistoryEntityPage.tsx:43
#: src/timber/pages/price/PriceDetailPage.tsx:63
#: src/timber/pages/price/PriceEntityPage.tsx:57
#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx:63
#: src/timber/pages/pricingProfile/PricingProfileEntityPage.tsx:57
#: src/timber/pages/provider/ProviderDetailPage.tsx:63
#: src/timber/pages/provider/ProviderEntityPage.tsx:57
#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx:71
#: src/timber/pages/providerUser/ProviderUserEntityPage.tsx:65
#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx:63
#: src/timber/pages/roadCarrier/RoadCarrierEntityPage.tsx:57
#: src/timber/pages/shipment/ShipmentDetailPage.tsx:74
#: src/timber/pages/shipment/ShipmentEntityPage.tsx:57
#: src/timber/pages/shipmentHistory/ShipmentHistoryDetailPage.tsx:49
#: src/timber/pages/shipmentHistory/ShipmentHistoryEntityPage.tsx:43
#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx:63
#: src/timber/pages/thicknessClass/ThicknessClassEntityPage.tsx:57
#: src/timber/pages/timberClass/TimberClassDetailPage.tsx:63
#: src/timber/pages/timberClass/TimberClassEntityPage.tsx:57
#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx:72
#: src/timber/pages/timberStorage/TimberStorageEntityPage.tsx:57
#: src/timber/pages/timberType/TimberTypeDetailPage.tsx:63
#: src/timber/pages/timberType/TimberTypeEntityPage.tsx:57
#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx:63
#: src/timber/pages/treeMarking/TreeMarkingEntityPage.tsx:57
msgid "Delete"
msgstr "Delete"

#: src/address/hooks/useAddress.ts:120
#: src/address/hooks/useUserAddress.ts:84
#: src/auth/hooks/useMembersGroup.ts:120
#: src/auth/hooks/useMembersGroupUser.ts:84
#: src/auth/hooks/useRole.ts:120
#: src/auth/hooks/useRoleAssignment.ts:84
#: src/auth/hooks/useRolePermission.ts:84
#: src/auth/hooks/useScopeGroup.ts:120
#: src/auth/hooks/useUser.ts:120
#: src/auth/hooks/useUserSession.ts:120
#: src/location/hooks/useLocation.ts:120
#: src/timber/hooks/useAccountingUser.ts:120
#: src/timber/hooks/useBuyer.ts:120
#: src/timber/hooks/useBuyerUser.ts:120
#: src/timber/hooks/useContractor.ts:120
#: src/timber/hooks/useContractorUser.ts:120
#: src/timber/hooks/useCordwood.ts:120
#: src/timber/hooks/useCordwoodHistory.ts:84
#: src/timber/hooks/useCutting.ts:120
#: src/timber/hooks/useForestOwner.ts:120
#: src/timber/hooks/useLog.ts:120
#: src/timber/hooks/useLogHistory.ts:84
#: src/timber/hooks/usePrice.ts:120
#: src/timber/hooks/usePricingProfile.ts:120
#: src/timber/hooks/useProvider.ts:120
#: src/timber/hooks/useProviderUser.ts:120
#: src/timber/hooks/useRoadCarrier.ts:120
#: src/timber/hooks/useShipment.ts:120
#: src/timber/hooks/useShipmentHistory.ts:84
#: src/timber/hooks/useThicknessClass.ts:120
#: src/timber/hooks/useTimberClass.ts:120
#: src/timber/hooks/useTimberStorage.ts:120
#: src/timber/hooks/useTimberType.ts:120
#: src/timber/hooks/useTreeMarking.ts:120
msgid "Delete error: "
msgstr "Delete error: "

#: src/address/components/address/AddressDetail/AddressDetail.tsx:76
#: src/address/components/address/AddressForm/AddressAddForm.tsx:247
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx:211
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx:65
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx:137
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateForm.tsx:82
#: src/auth/components/role/RoleDetail/RoleDetail.tsx:68
#: src/auth/components/role/RoleForm/RoleAddForm.tsx:149
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx:108
#: src/auth/components/role/RoleList/RoleListItem.tsx:256
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx:71
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:174
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx:108
#: src/location/components/location/LocationDetail/LocationDetail.tsx:61
#: src/location/components/location/LocationForm/LocationAddForm.tsx:181
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx:125
#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx:69
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx:139
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateForm.tsx:86
#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx:68
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx:179
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx:139
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx:281
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx:72
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx:162
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateForm.tsx:86
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx:68
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx:179
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx:139
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx:72
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:235
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:141
#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:135
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:442
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:299
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx:68
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx:176
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx:139
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:941
#: src/timber/components/log/LogDetail/LogDetail.tsx:151
#: src/timber/components/log/LogForm/LogAddForm.tsx:534
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:379
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileDetail.tsx:66
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddForm.tsx:107
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateForm.tsx:86
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx:68
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx:176
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx:139
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx:72
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:176
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx:97
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx:68
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx:120
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx:95
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:147
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:695
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:490
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:104
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:119
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx:69
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:182
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:148
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx:66
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx:135
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx:108
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx:66
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx:135
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx:108
msgid "Description"
msgstr "Description"

#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx:18
msgid "Details Accounting User"
msgstr "Details Accounting User"

#: src/address/pages/address/AddressDetailPage.tsx:18
msgid "Details Address"
msgstr "Details Address"

#: src/timber/pages/buyer/BuyerDetailPage.tsx:18
msgid "Details Buyer"
msgstr "Details Buyer"

#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx:18
msgid "Details Buyer User"
msgstr "Details Buyer User"

#: src/timber/pages/contractor/ContractorDetailPage.tsx:18
msgid "Details Contractor"
msgstr "Details Contractor"

#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx:18
msgid "Details Contractor User"
msgstr "Details Contractor User"

#: src/timber/pages/cordwood/CordwoodDetailPage.tsx:18
msgid "Details Cordwood"
msgstr "Details Cordwood"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryDetailPage.tsx:18
msgid "Details Cordwood History"
msgstr "Details Cordwood History"

#: src/timber/pages/cutting/CuttingDetailPage.tsx:19
msgid "Details Cutting"
msgstr "Details Cutting"

#: src/timber/pages/driver/DriverDetailPage.tsx:17
#~ msgid "Details Driver"
#~ msgstr "Details Driver"

#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx:18
msgid "Details Forest Owner"
msgstr "Details Forest Owner"

#: src/location/pages/location/LocationDetailPage.tsx:18
msgid "Details Location"
msgstr "Details Location"

#: src/timber/pages/log/LogDetailPage.tsx:18
msgid "Details Log"
msgstr "Details Log"

#: src/timber/pages/logHistory/LogHistoryDetailPage.tsx:18
msgid "Details Log History"
msgstr "Details Log History"

#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx:18
msgid "Details Members Group"
msgstr "Details Members Group"

#: src/auth/pages/membersGroupUser/MembersGroupUserDetailPage.tsx:18
msgid "Details Members Group User"
msgstr "Details Members Group User"

#: src/timber/pages/price/PriceDetailPage.tsx:18
msgid "Details Price"
msgstr "Details Price"

#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx:18
msgid "Details Pricing Profile"
msgstr "Details Pricing Profile"

#: src/timber/pages/provider/ProviderDetailPage.tsx:18
msgid "Details Provider"
msgstr "Details Provider"

#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx:18
msgid "Details Provider User"
msgstr "Details Provider User"

#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx:18
msgid "Details Road Carrier"
msgstr "Details Road Carrier"

#: src/auth/pages/role/RoleDetailPage.tsx:18
msgid "Details Role"
msgstr "Details Role"

#: src/auth/pages/roleAssignment/RoleAssignmentDetailPage.tsx:18
msgid "Details Role Assignment"
msgstr "Details Role Assignment"

#: src/auth/pages/rolePermission/RolePermissionDetailPage.tsx:18
msgid "Details Role Permission"
msgstr "Details Role Permission"

#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx:18
msgid "Details Scope Group"
msgstr "Details Scope Group"

#: src/timber/pages/shipment/ShipmentDetailPage.tsx:21
msgid "Details Shipment"
msgstr "Details Shipment"

#: src/timber/pages/shipmentHistory/ShipmentHistoryDetailPage.tsx:18
msgid "Details Shipment History"
msgstr "Details Shipment History"

#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx:18
msgid "Details Thickness Class"
msgstr "Details Thickness Class"

#: src/timber/pages/timberClass/TimberClassDetailPage.tsx:18
msgid "Details Timber Class"
msgstr "Details Timber Class"

#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx:21
msgid "Details Timber Storage"
msgstr "Details Timber Storage"

#: src/timber/pages/timberType/TimberTypeDetailPage.tsx:18
msgid "Details Timber Type"
msgstr "Details Timber Type"

#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx:18
msgid "Details Tree Marking"
msgstr "Details Tree Marking"

#: src/auth/pages/user/UserDetailPage.tsx:18
msgid "Details User"
msgstr "Details User"

#: src/address/pages/userAddress/UserAddressDetailPage.tsx:18
msgid "Details User Address"
msgstr "Details User Address"

#: src/auth/pages/userSession/UserSessionDetailPage.tsx:18
msgid "Details User Session"
msgstr "Details User Session"

#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx:73
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:173
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateForm.tsx:82
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx:327
msgid "Device"
msgstr "Device"

#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:94
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:385
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:97
msgid "Diameter"
msgstr "Diameter"

#: src/timber/components/log/LogDetail/LogDetail.tsx:93
#: src/timber/components/log/LogForm/LogAddForm.tsx:367
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:239
#: src/timber/components/log/LogList/LogListItem.tsx:638
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:131
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:645
msgid "Diameter (cm)"
msgstr "Diameter (cm)"

#: src/timber/components/log/LogList/LogListSearch.tsx:425
msgid "Diameter (cm) From"
msgstr "Diameter (cm) From"

#: src/timber/components/log/LogList/LogListSearch.tsx:435
msgid "Diameter (cm) To"
msgstr "Diameter (cm) To"

#: src/share/components/footer/Footer.tsx:27
msgid "Download Mobile App"
msgstr "Download Mobile App"

#: src/timber/components/driver/DriverDetail/DriverDetail.tsx:33
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:85
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:513
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:344
#: src/timber/pages/driver/DriverEntityPage.tsx:17
#~ msgid "Driver"
#~ msgstr "Driver"

#: src/timber/hooks/useDriver.ts:62
#~ msgid "Driver add error: "
#~ msgstr "Driver add error: "

#: src/timber/hooks/useDriver.ts:125
#~ msgid "Driver delete error: "
#~ msgstr "Driver delete error: "

#: src/timber/hooks/useDriver.ts:122
#~ msgid "Driver deleted"
#~ msgstr "Driver deleted"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:212
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:139
#~ msgid "Driver Id is required"
#~ msgstr "Driver Id is required"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:95
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:567
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:379
#~ msgid "Driver Name"
#~ msgstr "Driver Name"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:92
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:551
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:363
#~ msgid "Driver Registration Number"
#~ msgstr "Driver Registration Number"

#: src/timber/hooks/useDriver.ts:92
#~ msgid "Driver update error: "
#~ msgstr "Driver update error: "

#: src/timber/hooks/useDriver.ts:89
#~ msgid "Driver updated"
#~ msgstr "Driver updated"

#: src/app/mappers.tsx:211
#: src/timber/components/driver/DriverList/DriverListHeader.tsx:42
#: src/timber/pages/listItems.tsx:97
#~ msgid "Drivers"
#~ msgstr "Drivers"

#: src/share/components/layout/Layout/Trash.tsx:28
msgid "Drop here to delete"
msgstr "Drop here to delete"

#: src/address/components/address/AddressList/AddressListItemTools.tsx:40
#: src/address/components/userAddress/UserAddressList/UserAddressListItemTools.tsx:37
#: src/address/pages/address/AddressDetailPage.tsx:54
#: src/address/pages/address/AddressEntityPage.tsx:48
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItemTools.tsx:37
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItemTools.tsx:37
#: src/auth/components/role/RoleList/RoleListItemTools.tsx:37
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItemTools.tsx:37
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItemTools.tsx:37
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItemTools.tsx:37
#: src/auth/components/user/UserList/UserListItemTools.tsx:37
#: src/auth/components/userSession/UserSessionList/UserSessionListItemTools.tsx:37
#: src/auth/pages/membersGroup/MembersGroupDetailPage.tsx:51
#: src/auth/pages/membersGroup/MembersGroupEntityPage.tsx:45
#: src/auth/pages/role/RoleDetailPage.tsx:51
#: src/auth/pages/role/RoleEntityPage.tsx:45
#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx:62
#: src/auth/pages/scopeGroup/ScopeGroupEntityPage.tsx:45
#: src/auth/pages/user/UserDetailPage.tsx:51
#: src/auth/pages/user/UserEntityPage.tsx:45
#: src/auth/pages/userSession/UserSessionDetailPage.tsx:51
#: src/auth/pages/userSession/UserSessionEntityPage.tsx:45
#: src/location/components/location/LocationList/LocationListItemTools.tsx:40
#: src/location/pages/location/LocationDetailPage.tsx:54
#: src/location/pages/location/LocationEntityPage.tsx:48
#: src/share/components/breadcrumbs/RouterBreadcrumbs.tsx:36
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItemTools.tsx:40
#: src/timber/components/buyer/BuyerList/BuyerListItemTools.tsx:44
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItemTools.tsx:44
#: src/timber/components/contractor/ContractorList/ContractorListItemTools.tsx:44
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItemTools.tsx:48
#: src/timber/components/cordwood/CordwoodList/CordwoodListItemTools.tsx:42
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItemTools.tsx:40
#: src/timber/components/cutting/CuttingList/CuttingListItemTools.tsx:46
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItemTools.tsx:40
#: src/timber/components/log/LogList/LogListItemTools.tsx:41
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItemTools.tsx:40
#: src/timber/components/price/PriceList/PriceListItemTools.tsx:40
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItemTools.tsx:40
#: src/timber/components/provider/ProviderList/ProviderListItemTools.tsx:40
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItemTools.tsx:44
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItemTools.tsx:40
#: src/timber/components/shipment/ShipmentList/ShipmentListItemTools.tsx:47
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItemTools.tsx:40
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItemTools.tsx:40
#: src/timber/components/timberClass/TimberClassList/TimberClassListItemTools.tsx:40
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItemTools.tsx:48
#: src/timber/components/timberType/TimberTypeList/TimberTypeListItemTools.tsx:40
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItemTools.tsx:40
#: src/timber/pages/accountingUser/AccountingUserDetailPage.tsx:54
#: src/timber/pages/accountingUser/AccountingUserEntityPage.tsx:48
#: src/timber/pages/buyer/BuyerDetailPage.tsx:58
#: src/timber/pages/buyer/BuyerEntityPage.tsx:52
#: src/timber/pages/buyerUser/BuyerUserDetailPage.tsx:58
#: src/timber/pages/buyerUser/BuyerUserEntityPage.tsx:52
#: src/timber/pages/contractor/ContractorDetailPage.tsx:58
#: src/timber/pages/contractor/ContractorEntityPage.tsx:52
#: src/timber/pages/contractorUser/ContractorUserDetailPage.tsx:62
#: src/timber/pages/contractorUser/ContractorUserEntityPage.tsx:56
#: src/timber/pages/cordwood/CordwoodDetailPage.tsx:56
#: src/timber/pages/cordwood/CordwoodEntityPage.tsx:48
#: src/timber/pages/cutting/CuttingDetailPage.tsx:64
#: src/timber/pages/cutting/CuttingEntityPage.tsx:52
#: src/timber/pages/forestOwner/ForestOwnerDetailPage.tsx:54
#: src/timber/pages/forestOwner/ForestOwnerEntityPage.tsx:48
#: src/timber/pages/log/LogDetailPage.tsx:56
#: src/timber/pages/log/LogEntityPage.tsx:48
#: src/timber/pages/price/PriceDetailPage.tsx:54
#: src/timber/pages/price/PriceEntityPage.tsx:48
#: src/timber/pages/pricingProfile/PricingProfileDetailPage.tsx:54
#: src/timber/pages/pricingProfile/PricingProfileEntityPage.tsx:48
#: src/timber/pages/provider/ProviderDetailPage.tsx:54
#: src/timber/pages/provider/ProviderEntityPage.tsx:48
#: src/timber/pages/providerUser/ProviderUserDetailPage.tsx:58
#: src/timber/pages/providerUser/ProviderUserEntityPage.tsx:52
#: src/timber/pages/roadCarrier/RoadCarrierDetailPage.tsx:54
#: src/timber/pages/roadCarrier/RoadCarrierEntityPage.tsx:48
#: src/timber/pages/shipment/ShipmentDetailPage.tsx:63
#: src/timber/pages/shipment/ShipmentEntityPage.tsx:48
#: src/timber/pages/thicknessClass/ThicknessClassDetailPage.tsx:54
#: src/timber/pages/thicknessClass/ThicknessClassEntityPage.tsx:48
#: src/timber/pages/timberClass/TimberClassDetailPage.tsx:54
#: src/timber/pages/timberClass/TimberClassEntityPage.tsx:48
#: src/timber/pages/timberStorage/TimberStorageDetailPage.tsx:61
#: src/timber/pages/timberStorage/TimberStorageEntityPage.tsx:48
#: src/timber/pages/timberType/TimberTypeDetailPage.tsx:54
#: src/timber/pages/timberType/TimberTypeEntityPage.tsx:48
#: src/timber/pages/treeMarking/TreeMarkingDetailPage.tsx:54
#: src/timber/pages/treeMarking/TreeMarkingEntityPage.tsx:48
msgid "Edit"
msgstr "Edit"

#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx:28
msgid "Edit Accounting User"
msgstr "Edit Accounting User"

#: src/address/pages/address/AddressUpdateEditPage.tsx:28
msgid "Edit Address"
msgstr "Edit Address"

#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx:28
msgid "Edit Buyer"
msgstr "Edit Buyer"

#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx:28
msgid "Edit Buyer User"
msgstr "Edit Buyer User"

#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx:28
msgid "Edit Contractor"
msgstr "Edit Contractor"

#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx:28
msgid "Edit Contractor User"
msgstr "Edit Contractor User"

#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx:28
msgid "Edit Cordwood"
msgstr "Edit Cordwood"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx:28
msgid "Edit Cordwood History"
msgstr "Edit Cordwood History"

#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx:28
msgid "Edit Cutting"
msgstr "Edit Cutting"

#: src/timber/pages/driver/DriverUpdateEditPage.tsx:70
#~ msgid "Edit Driver"
#~ msgstr "Edit Driver"

#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx:28
msgid "Edit Forest Owner"
msgstr "Edit Forest Owner"

#: src/location/pages/location/LocationUpdateEditPage.tsx:28
msgid "Edit Location"
msgstr "Edit Location"

#: src/timber/pages/log/LogUpdateEditPage.tsx:28
msgid "Edit Log"
msgstr "Edit Log"

#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx:28
msgid "Edit Log History"
msgstr "Edit Log History"

#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx:28
msgid "Edit Members Group"
msgstr "Edit Members Group"

#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx:28
msgid "Edit Members Group User"
msgstr "Edit Members Group User"

#: src/timber/pages/price/PriceUpdateEditPage.tsx:28
msgid "Edit Price"
msgstr "Edit Price"

#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx:28
msgid "Edit Pricing Profile"
msgstr "Edit Pricing Profile"

#: src/timber/pages/provider/ProviderUpdateEditPage.tsx:28
msgid "Edit Provider"
msgstr "Edit Provider"

#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx:28
msgid "Edit Provider User"
msgstr "Edit Provider User"

#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx:28
msgid "Edit Road Carrier"
msgstr "Edit Road Carrier"

#: src/auth/pages/role/RoleUpdateEditPage.tsx:28
msgid "Edit Role"
msgstr "Edit Role"

#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx:28
msgid "Edit Role Assignment"
msgstr "Edit Role Assignment"

#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx:28
msgid "Edit Role Permission"
msgstr "Edit Role Permission"

#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx:28
msgid "Edit Scope Group"
msgstr "Edit Scope Group"

#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx:28
msgid "Edit Shipment"
msgstr "Edit Shipment"

#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx:28
msgid "Edit Shipment History"
msgstr "Edit Shipment History"

#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx:28
msgid "Edit Thickness Class"
msgstr "Edit Thickness Class"

#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx:28
msgid "Edit Timber Class"
msgstr "Edit Timber Class"

#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx:28
msgid "Edit Timber Storage"
msgstr "Edit Timber Storage"

#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx:28
msgid "Edit Timber Type"
msgstr "Edit Timber Type"

#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx:28
msgid "Edit Tree Marking"
msgstr "Edit Tree Marking"

#: src/auth/pages/user/UserUpdateEditPage.tsx:28
msgid "Edit User"
msgstr "Edit User"

#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx:28
msgid "Edit User Address"
msgstr "Edit User Address"

#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx:28
msgid "Edit User Session"
msgstr "Edit User Session"

#: src/address/components/address/AddressDetail/AddressDetail.tsx:67
#: src/address/components/address/AddressForm/AddressAddForm.tsx:202
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx:166
#: src/address/components/address/AddressList/AddressListItem.tsx:198
#: src/address/components/address/AddressList/AddressListItem.tsx:368
#: src/auth/components/user/UserDetail/UserDetail.tsx:62
#: src/auth/components/user/UserForm/UserAddForm.tsx:120
#: src/auth/components/user/UserList/UserListItem.tsx:175
#: src/auth/components/user/UserList/UserListItem.tsx:293
#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx:63
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx:109
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItem.tsx:255
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx:66
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx:132
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItem.tsx:260
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx:66
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:205
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx:389
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx:66
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:146
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx:303
msgid "Email"
msgstr "Email"

#: src/pages/ForgotPasswordPage.tsx:182
#: src/pages/LoginPage.tsx:139
#: src/pages/ProfilePage.tsx:48
msgid "Email Address"
msgstr "Email Address"

#: src/pages/ForgotPasswordPage.tsx:40
#: src/pages/LoginPage.tsx:40
msgid "Email Address is invalid"
msgstr "Email Address is invalid"

#: src/pages/ForgotPasswordPage.tsx:39
#: src/pages/LoginPage.tsx:39
msgid "Email address is required"
msgstr "Email address is required"

#: src/auth/components/user/UserForm/UserAddForm.tsx:87
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx:80
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx:97
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:140
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:105
msgid "Email is required"
msgstr "Email is required"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx:84
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:256
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:182
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx:366
msgid "End At"
msgstr "End At"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:168
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:106
msgid "End At is required"
msgstr "End At is required"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:198
msgid "End Date"
msgstr "End Date"

#: src/pages/ForgotPasswordPage.tsx:165
msgid "Enter your email address and we’ll send you a link to reset your password."
msgstr "Enter your email address and we’ll send you a link to reset your password."

#: src/share/components/alert/DescriptionAlert/useDescriptionAlert.ts:43
msgid "Error"
msgstr "Error"

#: src/timber/components/log/LogDetail/LogDetail.tsx:117
#: src/timber/components/log/LogForm/LogAddForm.tsx:442
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:314
#: src/timber/components/log/LogList/LogListItem.tsx:363
#: src/timber/components/log/LogList/LogListItem.tsx:754
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:429
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:130
msgid "External Key"
msgstr "External Key"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:272
#: src/timber/components/generic/report/GenericRootTable.tsx:94
msgid "Failed to load data"
msgstr "Failed to load data"

#: src/timber/types/models/CuttingState.d.ts:30
#: src/timber/types/models/ShipmentState.d.ts:30
msgid "Finished"
msgstr "Finished"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:144
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:683
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:478
msgid "For Personal Use"
msgstr "For Personal Use"

#: src/pages/PrivacyPolicyPage.tsx:24
msgid "For questions, contact: info@iokrono.com."
msgstr "For questions, contact: info@iokrono.com."

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx:103
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:325
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:223
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx:413
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx:288
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx:39
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx:84
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:185
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx:125
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx:329
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx:254
#: src/timber/pages/forestOwner/ForestOwnerEntityPage.tsx:17
msgid "Forest Owner"
msgstr "Forest Owner"

#: src/timber/hooks/useForestOwner.ts:65
msgid "Forest Owner add error: "
msgstr "Forest Owner add error: "

#: src/timber/hooks/useForestOwner.ts:131
msgid "Forest Owner delete error: "
msgstr "Forest Owner delete error: "

#: src/timber/hooks/useForestOwner.ts:128
msgid "Forest Owner deleted"
msgstr "Forest Owner deleted"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:167
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:112
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:94
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx:65
#~ msgid "Forest Owner Id is required"
#~ msgstr "Forest Owner Id is required"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:197
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:123
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:125
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx:79
msgid "Forest Owner is required"
msgstr "Forest Owner is required"

#: src/timber/hooks/useForestOwner.ts:98
msgid "Forest Owner update error: "
msgstr "Forest Owner update error: "

#: src/timber/hooks/useForestOwner.ts:95
msgid "Forest Owner updated"
msgstr "Forest Owner updated"

#: src/app/mappers.tsx:219
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListHeader.tsx:43
#: src/timber/pages/listItems.tsx:131
msgid "Forest Owners"
msgstr "Forest Owners"

#: src/pages/ForgotPasswordPage.tsx:47
#: src/pages/ForgotPasswordPage.tsx:155
msgid "Forgot Password"
msgstr "Forgot Password"

#: src/pages/LoginPage.tsx:146
msgid "Forgot Password?"
msgstr "Forgot Password?"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:669
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:682
#: src/timber/components/generic/report/GenericRootReport.tsx:370
#: src/timber/components/generic/report/GenericRootReport.tsx:383
#: src/timber/components/generic/report/TimelineRootReport.tsx:421
#: src/timber/components/generic/report/TimelineRootReport.tsx:427
msgid "From"
msgstr "From"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:669
#: src/timber/components/generic/report/GenericRootReport.tsx:370
#: src/timber/components/generic/report/TimelineRootReport.tsx:421
#~ msgid "From Input Date"
#~ msgstr "From Input Date"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:682
#: src/timber/components/generic/report/GenericRootReport.tsx:383
#: src/timber/components/generic/report/TimelineRootReport.tsx:427
#~ msgid "From Shipment Date"
#~ msgstr "From Shipment Date"

#: src/pages/ProfilePage.tsx:42
msgid "Full Name"
msgstr "Full Name"

#: src/share/components/scope/ScopeSwitcher.tsx:65
msgid "Global"
msgstr "Global"

#: src/pages/NotFoundPage.tsx:38
#: src/pages/UnauthorizedPage.tsx:43
msgid "Go Home"
msgstr "Go Home"

#: src/pages/NotFoundPage.tsx:39
#: src/pages/UnauthorizedPage.tsx:44
msgid "Go Login"
msgstr "Go Login"

#: src/timber/components/generic/report/GenericRootReport.tsx:399
msgid "Graphs"
msgstr "Graphs"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx:68
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx:151
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx:285
msgid "Group Type"
msgstr "Group Type"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx:99
msgid "Group Type is required"
msgstr "Group Type is required"

#: src/auth/components/user/UserForm/UserAddForm.tsx:135
#: src/auth/components/user/UserForm/UserUpdateForm.tsx:76
msgid "Hash Password"
msgstr "Hash Password"

#: src/auth/components/user/UserForm/UserAddForm.tsx:93
#: src/auth/components/user/UserForm/UserUpdateForm.tsx:49
msgid "Hash Password is required"
msgstr "Hash Password is required"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx:62
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItem.tsx:202
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItem.tsx:294
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx:268
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx:65
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx:298
#: src/location/components/location/LocationDetail/LocationDetail.tsx:64
#: src/location/components/location/LocationList/LocationListItem.tsx:203
#: src/location/components/location/LocationList/LocationListItem.tsx:318
#: src/location/components/location/LocationList/LocationListSearch.tsx:259
msgid "Hierarchy Name"
msgstr "Hierarchy Name"

#: src/app/App.tsx:59
#: src/app/App.tsx:105
msgid "Home"
msgstr "Home"

#: src/share/components/footer/Footer.tsx:32
msgid "How to Install APK on Android"
msgstr "How to Install APK on Android"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx:74
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx:209
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx:169
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx:74
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx:209
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx:169
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx:74
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx:206
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx:169
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx:74
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx:206
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx:169
msgid "Iban"
msgstr "Iban"

#: src/pages/ProfilePage.tsx:36
msgid "Id"
msgstr "Id"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:81
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:354
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:529
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:324
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:97
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:501
#: src/timber/components/log/LogDetail/LogDetail.tsx:84
#: src/timber/components/log/LogList/LogListItem.tsx:380
#: src/timber/components/log/LogList/LogListItem.tsx:587
#: src/timber/components/log/LogList/LogListSearch.tsx:362
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:100
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:503
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:445
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:124
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:439
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:140
msgid "IK"
msgstr "IK"

#: src/timber/types/models/CuttingState.d.ts:27
#: src/timber/types/models/ShipmentState.d.ts:27
msgid "In progress"
msgstr "In progress"

#: src/timber/components/generic/report/GenericRootShipments.tsx:204
#: src/timber/components/generic/report/GenericRootShipments.tsx:357
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:81
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:437
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:273
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:246
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:535
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:311
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:79
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:392
msgid "Key"
msgstr "Key"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:282
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:140
msgid "Key is required"
msgstr "Key is required"

#: src/share/components/localization/Locale/Locale.tsx:29
msgid "Language"
msgstr "Language"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:229
msgid "Last Month"
msgstr "Last Month"

#: src/pages/PrivacyPolicyPage.tsx:29
msgid "Last updated:"
msgstr "Last updated:"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:219
msgid "Last Week"
msgstr "Last Week"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:239
msgid "Last Year"
msgstr "Last Year"

#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:100
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:386
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:98
msgid "Length"
msgstr "Length"

#: src/timber/components/log/LogDetail/LogDetail.tsx:90
#: src/timber/components/log/LogForm/LogAddForm.tsx:350
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:222
#: src/timber/components/log/LogList/LogListItem.tsx:621
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:128
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:628
msgid "Length (cm)"
msgstr "Length (cm)"

#: src/timber/components/log/LogList/LogListSearch.tsx:396
msgid "Length (cm) From"
msgstr "Length (cm) From"

#: src/timber/components/log/LogList/LogListSearch.tsx:406
msgid "Length (cm) To"
msgstr "Length (cm) To"

#: src/pages/PreferencesPage.tsx:90
msgid "Light"
msgstr "Light"

#: src/timber/components/log/LogDetail/LogDetail.tsx:111
#: src/timber/components/log/LogForm/LogAddForm.tsx:413
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:285
#: src/timber/components/log/LogList/LogListItem.tsx:735
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:146
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:725
msgid "Linked"
msgstr "Linked"

#: src/timber/pages/accountingUser/AccountingUserListPage.tsx:10
msgid "List Accounting User"
msgstr "List Accounting User"

#: src/address/pages/address/AddressListPage.tsx:10
msgid "List Address"
msgstr "List Address"

#: src/timber/pages/buyer/BuyerListPage.tsx:10
msgid "List Buyer"
msgstr "List Buyer"

#: src/timber/pages/buyerUser/BuyerUserListPage.tsx:10
msgid "List Buyer User"
msgstr "List Buyer User"

#: src/timber/pages/contractor/ContractorListPage.tsx:10
msgid "List Contractor"
msgstr "List Contractor"

#: src/timber/pages/contractorUser/ContractorUserListPage.tsx:10
msgid "List Contractor User"
msgstr "List Contractor User"

#: src/timber/pages/cordwood/CordwoodListPage.tsx:10
msgid "List Cordwood"
msgstr "List Cordwood"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryListPage.tsx:10
msgid "List Cordwood History"
msgstr "List Cordwood History"

#: src/timber/pages/cutting/CuttingListPage.tsx:10
msgid "List Cutting"
msgstr "List Cutting"

#: src/timber/pages/driver/DriverListPage.tsx:10
#~ msgid "List Driver"
#~ msgstr "List Driver"

#: src/timber/pages/forestOwner/ForestOwnerListPage.tsx:10
msgid "List Forest Owner"
msgstr "List Forest Owner"

#: src/location/pages/location/LocationListPage.tsx:10
msgid "List Location"
msgstr "List Location"

#: src/timber/pages/log/LogListPage.tsx:10
msgid "List Log"
msgstr "List Log"

#: src/timber/pages/logHistory/LogHistoryListPage.tsx:10
msgid "List Log History"
msgstr "List Log History"

#: src/auth/pages/membersGroup/MembersGroupListPage.tsx:10
msgid "List Members Group"
msgstr "List Members Group"

#: src/auth/pages/membersGroupUser/MembersGroupUserListPage.tsx:10
msgid "List Members Group User"
msgstr "List Members Group User"

#: src/timber/pages/price/PriceListPage.tsx:10
msgid "List Price"
msgstr "List Price"

#: src/timber/pages/pricingProfile/PricingProfileListPage.tsx:10
msgid "List Pricing Profile"
msgstr "List Pricing Profile"

#: src/timber/pages/provider/ProviderListPage.tsx:10
msgid "List Provider"
msgstr "List Provider"

#: src/timber/pages/providerUser/ProviderUserListPage.tsx:10
msgid "List Provider User"
msgstr "List Provider User"

#: src/timber/pages/roadCarrier/RoadCarrierListPage.tsx:10
msgid "List Road Carrier"
msgstr "List Road Carrier"

#: src/auth/pages/role/RoleListPage.tsx:10
msgid "List Role"
msgstr "List Role"

#: src/auth/pages/roleAssignment/RoleAssignmentListPage.tsx:10
msgid "List Role Assignment"
msgstr "List Role Assignment"

#: src/auth/pages/rolePermission/RolePermissionListPage.tsx:10
msgid "List Role Permission"
msgstr "List Role Permission"

#: src/auth/pages/scopeGroup/ScopeGroupListPage.tsx:10
msgid "List Scope Group"
msgstr "List Scope Group"

#: src/timber/pages/shipment/ShipmentListPage.tsx:10
msgid "List Shipment"
msgstr "List Shipment"

#: src/timber/pages/shipmentHistory/ShipmentHistoryListPage.tsx:10
msgid "List Shipment History"
msgstr "List Shipment History"

#: src/timber/pages/thicknessClass/ThicknessClassListPage.tsx:10
msgid "List Thickness Class"
msgstr "List Thickness Class"

#: src/timber/pages/timberClass/TimberClassListPage.tsx:10
msgid "List Timber Class"
msgstr "List Timber Class"

#: src/timber/pages/timberStorage/TimberStorageListPage.tsx:10
msgid "List Timber Storage"
msgstr "List Timber Storage"

#: src/timber/pages/timberType/TimberTypeListPage.tsx:10
msgid "List Timber Type"
msgstr "List Timber Type"

#: src/timber/pages/treeMarking/TreeMarkingListPage.tsx:10
msgid "List Tree Marking"
msgstr "List Tree Marking"

#: src/auth/pages/user/UserListPage.tsx:10
msgid "List User"
msgstr "List User"

#: src/address/pages/userAddress/UserAddressListPage.tsx:10
msgid "List User Address"
msgstr "List User Address"

#: src/auth/pages/userSession/UserSessionListPage.tsx:10
msgid "List User Session"
msgstr "List User Session"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:126
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:403
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:139
#: src/timber/components/log/LogDetail/LogDetail.tsx:142
#: src/timber/components/log/LogForm/LogAddForm.tsx:495
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:155
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:109
msgid "Local Created At"
msgstr "Local Created At"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:494
#: src/timber/components/log/LogList/LogListSearch.tsx:607
msgid "Local Created At From"
msgstr "Local Created At From"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:495
#: src/timber/components/log/LogList/LogListSearch.tsx:608
msgid "Local Created At To"
msgstr "Local Created At To"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:132
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:429
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:286
#: src/timber/components/log/LogDetail/LogDetail.tsx:148
#: src/timber/components/log/LogForm/LogAddForm.tsx:521
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:366
msgid "Local Deleted At"
msgstr "Local Deleted At"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:129
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:416
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:273
#: src/timber/components/log/LogDetail/LogDetail.tsx:145
#: src/timber/components/log/LogForm/LogAddForm.tsx:508
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:353
msgid "Local Updated At"
msgstr "Local Updated At"

#: src/location/components/location/LocationDetail/LocationDetail.tsx:32
#: src/location/components/location/LocationDetail/LocationDetail.tsx:80
#: src/location/components/location/LocationList/LocationListSearch.tsx:276
#: src/location/pages/location/LocationEntityPage.tsx:17
#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:112
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:108
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:553
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx:91
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:283
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:209
#: src/timber/components/log/LogDetail/LogDetail.tsx:128
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:114
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:572
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:103
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx:80
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:171
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx:111
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx:310
msgid "Location"
msgstr "Location"

#: src/location/hooks/useLocation.ts:65
msgid "Location add error: "
msgstr "Location add error: "

#: src/location/hooks/useLocation.ts:131
msgid "Location delete error: "
msgstr "Location delete error: "

#: src/location/hooks/useLocation.ts:128
msgid "Location deleted"
msgstr "Location deleted"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:146
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:147
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:103
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:104
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:87
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:88
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx:58
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx:59
#~ msgid "Location Id is required"
#~ msgstr "Location Id is required"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:179
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:180
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:117
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:118
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:119
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:120
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx:73
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx:74
msgid "Location is required"
msgstr "Location is required"

#: src/location/hooks/useLocation.ts:98
msgid "Location update error: "
msgstr "Location update error: "

#: src/location/hooks/useLocation.ts:95
msgid "Location updated"
msgstr "Location updated"

#: src/app/mappers.tsx:207
#: src/location/components/location/LocationDetail/LocationTabs.tsx:43
#: src/location/components/location/LocationList/LocationListHeader.tsx:44
#: src/location/pages/listItems.tsx:24
#: src/location/pages/listItems.tsx:55
msgid "Locations"
msgstr "Locations"

#: src/timber/components/log/LogDetail/LogDetail.tsx:58
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:88
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx:181
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:197
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:434
#: src/timber/pages/log/LogEntityPage.tsx:17
msgid "Log"
msgstr "Log"

#: src/timber/hooks/useLog.ts:65
msgid "Log add error: "
msgstr "Log add error: "

#: src/timber/hooks/useLog.ts:131
msgid "Log delete error: "
msgstr "Log delete error: "

#: src/timber/hooks/useLog.ts:128
msgid "Log deleted"
msgstr "Log deleted"

#: src/app/mappers.tsx:229
#: src/timber/components/log/LogDetail/LogTabs.tsx:41
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListHeader.tsx:44
msgid "Log Histories"
msgstr "Log Histories"

#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:61
#: src/timber/pages/logHistory/LogHistoryEntityPage.tsx:17
msgid "Log History"
msgstr "Log History"

#: src/timber/hooks/useLogHistory.ts:60
msgid "Log History add error: "
msgstr "Log History add error: "

#: src/timber/hooks/useLogHistory.ts:95
msgid "Log History delete error: "
msgstr "Log History delete error: "

#: src/timber/hooks/useLogHistory.ts:92
msgid "Log History deleted"
msgstr "Log History deleted"

#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx:113
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx:114
#~ msgid "Log Id is required"
#~ msgstr "Log Id is required"

#: src/pages/LoginPage.tsx:173
msgid "Log in with another provider"
msgstr "Log in with another provider"

#: src/pages/LoginPage.tsx:168
#~ msgid "Log in with another provider:"
#~ msgstr "Log in with another provider:"

#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx:146
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx:147
msgid "Log is required"
msgstr "Log is required"

#: src/timber/components/generic/report/GenericRootReport.tsx:400
msgid "Log Shipments"
msgstr "Log Shipments"

#: src/timber/hooks/useLog.ts:98
msgid "Log update error: "
msgstr "Log update error: "

#: src/timber/hooks/useLog.ts:95
msgid "Log updated"
msgstr "Log updated"

#: src/app/App.tsx:107
#: src/app/App.tsx:125
msgid "Login"
msgstr "Login"

#: src/pages/LoginPage.tsx:123
msgid "Login to have access!"
msgstr "Login to have access!"

#: src/app/App.tsx:120
msgid "Logout"
msgstr "Logout"

#: src/app/mappers.tsx:226
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:66
#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx:141
#: src/timber/components/generic/report/GenericRootShipments.tsx:79
#: src/timber/components/generic/report/StorageShipmentPies.tsx:141
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:401
#: src/timber/components/log/LogList/LogListHeader.tsx:53
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx:151
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx:63
#: src/timber/types/models/ShipmentType.d.ts:24
msgid "Logs"
msgstr "Logs"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:738
#: src/timber/components/generic/report/GenericRootShipments.tsx:224
#: src/timber/components/generic/report/GenericRootShipments.tsx:430
#: src/timber/components/generic/report/GenericRootTable.tsx:132
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:421
msgid "Logs Count"
msgstr "Logs Count"

#: src/timber/types/models/CordwoodMeasurementType.d.ts:24
msgid "m3"
msgstr "m³"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:701
msgid "Matched rows"
msgstr "Matched rows"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx:75
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:214
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:180
msgid "Max Diameter"
msgstr "Max Diameter"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:135
msgid "Measurement Type"
msgstr "Measurement Unit"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:221
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:133
#~ msgid "Measurement Type is required"
#~ msgstr "Measurement Unit is required"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx:96
#: src/auth/components/role/RoleForm/RoleAddForm.tsx:163
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:119
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:202
msgid "Member Group"
msgstr "Member Group"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx:73
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx:74
#: src/auth/components/role/RoleForm/RoleAddForm.tsx:101
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:90
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:91
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:126
msgid "Member Group is required"
msgstr "Member Group is required"

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx:33
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx:72
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx:300
#: src/auth/components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserDetail.tsx:66
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem.tsx:167
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx:259
#: src/auth/components/role/RoleDetail/RoleDetail.tsx:72
#: src/auth/components/role/RoleList/RoleListItem.tsx:336
#: src/auth/components/role/RoleList/RoleListSearch.tsx:284
#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx:69
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx:183
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx:328
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx:285
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx:79
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx:352
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx:277
#: src/auth/components/user/UserDetail/UserDetail.tsx:78
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx:70
#: src/auth/pages/membersGroup/MembersGroupEntityPage.tsx:17
#: src/auth/types/models/GroupType.d.ts:24
msgid "Members Group"
msgstr "Members Group"

#: src/auth/hooks/useMembersGroup.ts:65
msgid "Members Group add error: "
msgstr "Members Group add error: "

#: src/auth/hooks/useMembersGroup.ts:131
msgid "Members Group delete error: "
msgstr "Members Group delete error: "

#: src/auth/hooks/useMembersGroup.ts:128
msgid "Members Group deleted"
msgstr "Members Group deleted"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx:50
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx:51
#: src/auth/components/role/RoleForm/RoleAddForm.tsx:77
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:65
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:66
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:103
#~ msgid "Members Group Id is required"
#~ msgstr "Members Group Id is required"

#: src/auth/hooks/useMembersGroup.ts:98
msgid "Members Group update error: "
msgstr "Members Group update error: "

#: src/auth/hooks/useMembersGroup.ts:95
msgid "Members Group updated"
msgstr "Members Group updated"

#: src/auth/components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserDetail.tsx:39
#: src/auth/pages/membersGroupUser/MembersGroupUserEntityPage.tsx:17
msgid "Members Group User"
msgstr "Members Group User"

#: src/auth/hooks/useMembersGroupUser.ts:60
msgid "Members Group User add error: "
msgstr "Members Group User add error: "

#: src/auth/hooks/useMembersGroupUser.ts:95
msgid "Members Group User delete error: "
msgstr "Members Group User delete error: "

#: src/auth/hooks/useMembersGroupUser.ts:92
msgid "Members Group User deleted"
msgstr "Members Group User deleted"

#: src/app/mappers.tsx:203
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx:55
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListHeader.tsx:45
#: src/auth/components/user/UserDetail/UserTabs.tsx:56
msgid "Members Group Users"
msgstr "Members Group Users"

#: src/app/mappers.tsx:198
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx:46
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListHeader.tsx:44
#: src/auth/pages/listItems.tsx:24
msgid "Members Groups"
msgstr "Members Groups"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx:72
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:197
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:163
msgid "Min Diameter"
msgstr "Min Diameter"

#: src/address/components/address/AddressDetail/AddressDetail.tsx:73
#: src/address/components/address/AddressForm/AddressAddForm.tsx:232
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx:196
#: src/address/components/address/AddressList/AddressListItem.tsx:304
msgid "Mobile Phone"
msgstr "Mobile Phone"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:168
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:77
msgid "Move to this shipment"
msgstr "Move to this shipment"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:90
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:323
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:207
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:580
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:387
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:125
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:626
msgid "MU"
msgstr "MU"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:222
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:133
msgid "MU is required"
msgstr "MU is required"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:216
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:127
#: src/timber/components/log/LogForm/LogAddForm.tsx:243
#: src/timber/components/log/LogForm/LogAddForm.tsx:249
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:142
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:148
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:138
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:97
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:126
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:132
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:92
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:98
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:105
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingUpdateForm.tsx:43
msgid "must be a number."
msgstr "must be a number."

#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupDetail.tsx:59
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx:122
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateForm.tsx:67
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItem.tsx:277
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx:251
#: src/auth/components/role/RoleDetail/RoleDetail.tsx:62
#: src/auth/components/role/RoleForm/RoleAddForm.tsx:119
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx:78
#: src/auth/components/role/RoleList/RoleListItem.tsx:204
#: src/auth/components/role/RoleList/RoleListItem.tsx:297
#: src/auth/components/role/RoleList/RoleListSearch.tsx:245
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx:62
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:144
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx:78
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx:205
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx:281
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx:243
#: src/location/components/location/LocationDetail/LocationDetail.tsx:58
#: src/location/components/location/LocationForm/LocationAddForm.tsx:166
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx:110
#: src/location/components/location/LocationList/LocationListSearch.tsx:242
#: src/timber/components/accountingUser/AccountingUserDetail/AccountingUserDetail.tsx:66
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx:124
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateForm.tsx:71
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItem.tsx:180
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItem.tsx:272
#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx:65
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx:164
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx:124
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx:177
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx:270
#: src/timber/components/buyerUser/BuyerUserDetail/BuyerUserDetail.tsx:69
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx:147
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateForm.tsx:71
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItem.tsx:185
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItem.tsx:277
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx:65
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx:164
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx:124
#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx:177
#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx:270
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx:69
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:220
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:126
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx:185
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx:406
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx:75
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:215
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:141
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx:222
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx:315
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx:255
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx:65
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx:161
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx:124
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx:177
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx:270
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:935
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileDetail.tsx:63
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddForm.tsx:92
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateForm.tsx:71
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItem.tsx:170
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx:65
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx:161
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx:124
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx:177
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx:270
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx:69
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:161
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx:82
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx:185
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx:320
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx:65
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx:105
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx:80
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItem.tsx:172
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx:66
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:167
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:133
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItem.tsx:175
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx:63
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx:120
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx:93
#: src/timber/components/timberClass/TimberClassList/TimberClassListItem.tsx:170
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx:72
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:143
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx:97
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx:219
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx:294
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx:237
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx:63
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx:120
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx:93
#: src/timber/components/timberType/TimberTypeList/TimberTypeListItem.tsx:170
msgid "Name"
msgstr "Name"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx:87
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateForm.tsx:44
#: src/auth/components/role/RoleForm/RoleAddForm.tsx:84
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx:49
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:103
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx:49
#: src/location/components/location/LocationForm/LocationAddForm.tsx:113
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx:63
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserAddForm.tsx:86
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateForm.tsx:48
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx:115
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx:75
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserAddForm.tsx:103
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateForm.tsx:48
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx:115
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx:75
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:146
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:73
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:150
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:88
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx:112
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx:75
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileAddForm.tsx:69
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateForm.tsx:48
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx:112
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx:75
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:111
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx:53
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierAddForm.tsx:80
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateForm.tsx:55
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:114
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:80
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx:85
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx:58
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageAddForm.tsx:108
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateForm.tsx:68
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx:85
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx:58
msgid "Name is required"
msgstr "Name is required"

#: src/pages/ChangePasswordPage.tsx:153
msgid "New Password"
msgstr "New Password"

#: src/pages/ChangePasswordPage.tsx:45
msgid "New password is required"
msgstr "New password is required"

#: src/pages/ChangePasswordPage.tsx:46
msgid "New password must be more than 8 characters"
msgstr "New password must be more than 8 characters"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:386
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:402
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:88
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:94
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:367
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:383
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:89
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:95
msgid "No"
msgstr "No"

#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItem.tsx:374
msgid "No Accounting Users"
msgstr "No Accounting Users"

#: src/address/components/address/AddressList/AddressListItem.tsx:453
msgid "No Addresses"
msgstr "No Addresses"

#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItem.tsx:387
msgid "No Buyer Users"
msgstr "No Buyer Users"

#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx:437
msgid "No Buyers"
msgstr "No Buyers"

#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx:580
msgid "No Contractor Users"
msgstr "No Contractor Users"

#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx:405
msgid "No Contractors"
msgstr "No Contractors"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx:169
msgid "No cordwood data"
msgstr "No cordwood data"

#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:1128
msgid "No Cordwood Histories"
msgstr "No Cordwood Histories"

#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:1028
msgid "No Cordwoods"
msgstr "No Cordwoods"

#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx:622
msgid "No Cuttings"
msgstr "No Cuttings"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx:174
msgid "No data"
msgstr "No data"

#: src/timber/components/driver/DriverList/DriverListItem.tsx:243
#~ msgid "No Drivers"
#~ msgstr "No Drivers"

#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx:401
msgid "No Forest Owners"
msgstr "No Forest Owners"

#: src/location/components/location/LocationList/LocationListItem.tsx:529
msgid "No Locations"
msgstr "No Locations"

#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:1268
msgid "No Log Histories"
msgstr "No Log Histories"

#: src/timber/components/log/LogList/LogListItem.tsx:1224
msgid "No Logs"
msgstr "No Logs"

#: src/timber/components/cutting/CuttingList/ActiveCuttings.tsx:153
msgid "No logs data"
msgstr "No logs data"

#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem.tsx:273
msgid "No Members Group Users"
msgstr "No Members Group Users"

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItem.tsx:396
msgid "No Members Groups"
msgstr "No Members Groups"

#: src/timber/components/price/PriceList/PriceListItem.tsx:422
msgid "No Prices"
msgstr "No Prices"

#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItem.tsx:239
msgid "No Pricing Profiles"
msgstr "No Pricing Profiles"

#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx:474
msgid "No Provider Users"
msgstr "No Provider Users"

#: src/timber/components/provider/ProviderList/ProviderListItem.tsx:401
msgid "No Providers"
msgstr "No Providers"

#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItem.tsx:245
msgid "No Road Carriers"
msgstr "No Road Carriers"

#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx:518
msgid "No Role Assignments"
msgstr "No Role Assignments"

#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx:352
msgid "No Role Permissions"
msgstr "No Role Permissions"

#: src/auth/components/role/RoleList/RoleListItem.tsx:454
msgid "No Roles"
msgstr "No Roles"

#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx:525
msgid "No Scope Groups"
msgstr "No Scope Groups"

#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:808
msgid "No Shipment Histories"
msgstr "No Shipment Histories"

#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:926
msgid "No Shipments"
msgstr "No Shipments"

#: src/timber/components/generic/report/GenericRootShipments.tsx:169
msgid "No shipments found"
msgstr "No shipments found"

#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItem.tsx:306
msgid "No Thickness Classes"
msgstr "No Thickness Classes"

#: src/timber/components/timberClass/TimberClassList/TimberClassListItem.tsx:247
msgid "No Timber Classes"
msgstr "No Timber Classes"

#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItem.tsx:449
msgid "No Timber Storages"
msgstr "No Timber Storages"

#: src/timber/components/timberType/TimberTypeList/TimberTypeListItem.tsx:247
msgid "No Timber Types"
msgstr "No Timber Types"

#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx:491
msgid "No Tree Markings"
msgstr "No Tree Markings"

#: src/address/components/userAddress/UserAddressList/UserAddressListItem.tsx:270
msgid "No User Addresses"
msgstr "No User Addresses"

#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx:467
msgid "No User Sessions"
msgstr "No User Sessions"

#: src/auth/components/user/UserList/UserListItem.tsx:500
msgid "No Users"
msgstr "No Users"

#: src/timber/types/models/UserType.d.ts:27
msgid "Normal"
msgstr "Normal"

#: src/pages/NotFoundPage.tsx:10
msgid "Not Found"
msgstr "Not Found"

#: src/pages/NotFoundPage.tsx:29
msgid "Not Found Page"
msgstr "Not Found Page"

#: src/location/components/location/LocationDetail/LocationDetail.tsx:76
#: src/location/components/location/LocationForm/LocationAddForm.tsx:241
#: src/location/components/location/LocationForm/LocationUpdateForm.tsx:185
msgid "Note"
msgstr "Note"

#: src/timber/types/models/CordwoodMeasurementType.d.ts:30
msgid "npm"
msgstr "npm"

#: src/timber/components/generic/report/GenericRootReportPdfDialog.tsx:108
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListPdfDialog.tsx:177
#: src/timber/components/shipment/ShipmentRegulator/CordwoodShipmentReportPdfDialog.tsx:84
#: src/timber/components/shipment/ShipmentRegulator/LogListPdfDialog.tsx:169
#: src/timber/components/shipment/ShipmentRegulator/LogShipmentReportPdfDialog.tsx:84
msgid "Number of copies"
msgstr "Number of copies"

#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx:28
#~ msgid "Ok"
#~ msgstr "Ok"

#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx:28
#: src/share/components/form/FormDateTime/FormDate.tsx:64
#: src/share/components/form/FormDateTime/FormDateTime.tsx:65
msgid "OK"
msgstr "OK"

#: src/pages/ChangePasswordPage.tsx:152
msgid "Old Password"
msgstr "Old Password"

#: src/pages/ChangePasswordPage.tsx:41
msgid "Old password is required"
msgstr "Old password is required"

#: src/pages/ChangePasswordPage.tsx:42
msgid "Old password must be more than 8 characters"
msgstr "Old password must be more than 8 characters"

#: src/app/App.tsx:304
msgid "Open settings"
msgstr "Open settings"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx:57
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx:58
#~ msgid "Owned Members Group Id is required"
#~ msgstr "Owned Members Group Id is required"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx:110
msgid "Owner Member Group"
msgstr "Owner Member Group"

#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx:79
#: src/auth/components/membersGroupUser/MembersGroupUserForm/MembersGroupUserAddForm.tsx:80
msgid "Owner Member Group is required"
msgstr "Owner Member Group is required"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx:164
#: src/location/components/location/LocationForm/LocationAddForm.tsx:255
msgid "Parent"
msgstr "Parent"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx:81
#: src/location/components/location/LocationForm/LocationAddForm.tsx:122
#~ msgid "Parent Id is required"
#~ msgstr "Parent Id is required"

#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupAddForm.tsx:104
#: src/location/components/location/LocationForm/LocationAddForm.tsx:148
msgid "Parent is required"
msgstr "Parent is required"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:188
msgid "Parent Scope Group"
msgstr "Parent Scope Group"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:96
#~ msgid "Parent Scope Group Id is required"
#~ msgstr "Parent Scope Group Id is required"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:120
msgid "Parent Scope Group is required"
msgstr "Parent Scope Group is required"

#: src/pages/LoginPage.tsx:140
#: src/pages/ResetPasswordPage.tsx:151
msgid "Password"
msgstr "Password"

#: src/pages/LoginPage.tsx:43
#: src/pages/ResetPasswordPage.tsx:41
msgid "Password is required"
msgstr "Password is required"

#: src/pages/LoginPage.tsx:45
msgid "Password must be less than 32 characters"
msgstr "Password must be less than 32 characters"

#: src/pages/LoginPage.tsx:44
#: src/pages/ResetPasswordPage.tsx:42
msgid "Password must be more than 8 characters"
msgstr "Password must be more than 8 characters"

#: src/pages/ChangePasswordPage.tsx:81
#: src/pages/ResetPasswordPage.tsx:80
msgid "Password updated successfully, login"
msgstr "Password updated successfully, login"

#: src/pages/ChangePasswordPage.tsx:51
#: src/pages/ResetPasswordPage.tsx:47
msgid "Passwords do not match"
msgstr "Passwords do not match"

#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx:66
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx:108
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx:222
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx:255
msgid "Permission"
msgstr "Permission"

#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx:77
msgid "Permission is required"
msgstr "Permission is required"

#: src/address/components/address/AddressDetail/AddressDetail.tsx:70
#: src/address/components/address/AddressForm/AddressAddForm.tsx:217
#: src/address/components/address/AddressForm/AddressUpdateForm.tsx:181
#: src/address/components/address/AddressList/AddressListItem.tsx:321
msgid "Phone"
msgstr "Phone"

#: src/share/components/dialog/DeleteDialog/DeleteDialog.tsx:24
#: src/share/components/dialog/PasswordDialog/PasswordDialog.tsx:23
msgid "Please confirm delete of the entity."
msgstr "Please confirm delete of the entity."

#: src/pages/ResetPasswordPage.tsx:45
msgid "Please confirm your password"
msgstr "Please confirm your password"

#: src/pages/ActivationPage.tsx:136
msgid "Please enter a activation ocode"
msgstr "Please enter a activation ocode"

#: src/pages/ChangePasswordPage.tsx:137
#: src/pages/ResetPasswordPage.tsx:136
msgid "Please enter a new password"
msgstr "Please enter a new password"

#: src/app/App.tsx:117
#: src/app/App.tsx:124
#: src/pages/PreferencesPage.tsx:39
#: src/pages/PreferencesPage.tsx:59
msgid "Preferences"
msgstr "Preferences"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:157
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:740
#: src/timber/components/price/PriceDetail/PriceDetail.tsx:49
#: src/timber/components/price/PriceDetail/PriceDetail.tsx:91
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:211
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:156
#: src/timber/components/price/PriceList/PriceListItem.tsx:280
#: src/timber/pages/price/PriceEntityPage.tsx:17
msgid "Price"
msgstr "Price"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:157
msgid "Price [Original: {originalValue}]"
msgstr "Price [Original: {originalValue}]"

#: src/timber/hooks/usePrice.ts:65
msgid "Price add error: "
msgstr "Price add error: "

#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx:67
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:84
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx:73
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:535
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx:92
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx:159
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx:81
msgid "Price Calculator"
msgstr "Price Calculator"

#: src/timber/hooks/usePrice.ts:131
msgid "Price delete error: "
msgstr "Price delete error: "

#: src/timber/hooks/usePrice.ts:128
msgid "Price deleted"
msgstr "Price deleted"

#: src/timber/hooks/usePrice.ts:98
msgid "Price update error: "
msgstr "Price update error: "

#: src/timber/hooks/usePrice.ts:95
msgid "Price updated"
msgstr "Price updated"

#: src/app/mappers.tsx:213
#: src/timber/components/price/PriceList/PriceListHeader.tsx:44
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileTabs.tsx:41
msgid "Prices"
msgstr "Prices"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:690
#: src/timber/components/price/PriceDetail/PriceDetail.tsx:76
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:154
#: src/timber/components/pricingProfile/PricingProfileDetail/PricingProfileDetail.tsx:37
#: src/timber/pages/pricingProfile/PricingProfileEntityPage.tsx:17
msgid "Pricing Profile"
msgstr "Pricing Profile"

#: src/timber/hooks/usePricingProfile.ts:65
msgid "Pricing Profile add error: "
msgstr "Pricing Profile add error: "

#: src/timber/hooks/usePricingProfile.ts:131
msgid "Pricing Profile delete error: "
msgstr "Pricing Profile delete error: "

#: src/timber/hooks/usePricingProfile.ts:128
msgid "Pricing Profile deleted"
msgstr "Pricing Profile deleted"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx:84
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:85
#~ msgid "Pricing Profile Id is required"
#~ msgstr "Pricing Profile Id is required"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx:113
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:114
msgid "Pricing Profile is required"
msgstr "Pricing Profile is required"

#: src/timber/hooks/usePricingProfile.ts:98
msgid "Pricing Profile update error: "
msgstr "Pricing Profile update error: "

#: src/timber/hooks/usePricingProfile.ts:95
msgid "Pricing Profile updated"
msgstr "Pricing Profile updated"

#: src/app/mappers.tsx:212
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListHeader.tsx:43
#: src/timber/pages/listItems.tsx:63
msgid "Pricing Profiles"
msgstr "Pricing Profiles"

#: src/app/App.tsx:128
#: src/pages/LoginPage.tsx:226
#: src/pages/PrivacyPolicyPage.tsx:10
#: src/pages/TermsPage.tsx:24
#: src/share/components/gdpr/CookieConsent.tsx:36
msgid "Privacy Policy"
msgstr "Privacy Policy"

#: src/timber/types/models/CordwoodMeasurementType.d.ts:27
msgid "prm"
msgstr "prm"

#: src/app/App.tsx:116
#: src/pages/ProfilePage.tsx:11
msgid "Profile"
msgstr "Profile"

#: src/pages/ProfilePage.tsx:31
msgid "Profile Page"
msgstr "Profile Page"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx:95
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:297
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx:39
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx:79
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:203
#: src/timber/pages/listItems.tsx:152
#: src/timber/pages/provider/ProviderEntityPage.tsx:17
msgid "Provider"
msgstr "Provider"

#: src/timber/hooks/useProvider.ts:65
msgid "Provider add error: "
msgstr "Provider add error: "

#: src/timber/hooks/useProvider.ts:131
msgid "Provider delete error: "
msgstr "Provider delete error: "

#: src/timber/hooks/useProvider.ts:128
msgid "Provider deleted"
msgstr "Provider deleted"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:153
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:154
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:102
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:103
#~ msgid "Provider Id is required"
#~ msgstr "Provider Id is required"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:185
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:186
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:128
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:129
msgid "Provider is required"
msgstr "Provider is required"

#: src/timber/hooks/useProvider.ts:98
msgid "Provider update error: "
msgstr "Provider update error: "

#: src/timber/hooks/useProvider.ts:95
msgid "Provider updated"
msgstr "Provider updated"

#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx:40
#: src/timber/pages/providerUser/ProviderUserEntityPage.tsx:17
msgid "Provider User"
msgstr "Provider User"

#: src/timber/hooks/useProviderUser.ts:65
msgid "Provider User add error: "
msgstr "Provider User add error: "

#: src/timber/hooks/useProviderUser.ts:131
msgid "Provider User delete error: "
msgstr "Provider User delete error: "

#: src/timber/hooks/useProviderUser.ts:128
msgid "Provider User deleted"
msgstr "Provider User deleted"

#: src/timber/hooks/useProviderUser.ts:98
msgid "Provider User update error: "
msgstr "Provider User update error: "

#: src/timber/hooks/useProviderUser.ts:95
msgid "Provider User updated"
msgstr "Provider User updated"

#: src/app/mappers.tsx:221
#: src/auth/components/user/UserDetail/UserTabs.tsx:62
#: src/timber/components/provider/ProviderDetail/ProviderTabs.tsx:42
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListHeader.tsx:44
msgid "Provider Users"
msgstr "Provider Users"

#: src/app/mappers.tsx:220
#: src/timber/components/provider/ProviderList/ProviderListHeader.tsx:43
#: src/timber/pages/listItems.tsx:144
msgid "Providers"
msgstr "Providers"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:191
msgid "Quick Select"
msgstr "Quick Select"

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx:340
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx:328
#: src/auth/components/role/RoleList/RoleListSearch.tsx:324
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx:391
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx:273
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx:317
#: src/location/components/location/LocationList/LocationListSearch.tsx:316
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:509
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx:331
#: src/timber/components/log/LogList/LogListSearch.tsx:622
#: src/timber/components/price/PriceList/PriceListSearch.tsx:329
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:454
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx:282
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx:346
msgid "Refresh"
msgstr "Refresh"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:158
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateForm.tsx:67
msgid "Refresh Token"
msgstr "Refresh Token"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:107
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateForm.tsx:44
msgid "Refresh Token is required"
msgstr "Refresh Token is required"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:175
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:82
msgid "Remove from this shipment"
msgstr "Remove from this shipment"

#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx:64
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx:88
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx:155
msgid "Report"
msgstr "Report"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx:88
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:75
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx:64
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx:72
msgid "Report All"
msgstr "Report All"

#: src/timber/components/generic/report/GenericRootShipments.tsx:263
#: src/timber/components/generic/report/GenericRootShipments.tsx:372
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:84
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:356
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:552
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:328
msgid "Report Key"
msgstr "Report Key"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx:81
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:246
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:212
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx:72
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx:165
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx:138
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx:72
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx:165
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx:138
msgid "Report Name Long"
msgstr "Report Name Long"

#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx:78
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:231
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:197
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx:69
#: src/timber/components/timberClass/TimberClassForm/TimberClassAddForm.tsx:150
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateForm.tsx:123
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx:69
#: src/timber/components/timberType/TimberTypeForm/TimberTypeAddForm.tsx:150
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateForm.tsx:123
msgid "Report Name Short"
msgstr "Report Name Short"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx:91
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:78
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx:67
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx:75
msgid "Report Not shipt"
msgstr "Report Not shipt"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx:94
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:81
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx:70
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx:78
msgid "Report Shipt"
msgstr "Report Shipt"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:375
msgid "Report TreeMarkings"
msgstr "Report TreeMarkings"

#: src/pages/listItems.tsx:30
#: src/pages/ReportsPage.tsx:9
msgid "Reports"
msgstr "Reports"

#: src/share/components/gdpr/CookieConsent.tsx:23
msgid "Reset"
msgstr "Reset"

#: src/auth/pages/scopeGroup/ScopeGroupDetailPage.tsx:73
msgid "Reset Assign"
msgstr "Reset Assign"

#: src/pages/ResetPasswordPage.tsx:55
#: src/pages/ResetPasswordPage.tsx:126
#: src/pages/ResetPasswordPage.tsx:166
msgid "Reset Password"
msgstr "Reset Password"

#: src/pages/ForgotPasswordPage.tsx:192
msgid "Retrieve Password"
msgstr "Retrieve Password"

#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierDetail.tsx:39
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:129
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:607
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:402
#: src/timber/pages/roadCarrier/RoadCarrierEntityPage.tsx:17
msgid "Road Carrier"
msgstr "Road Carrier"

#: src/timber/hooks/useRoadCarrier.ts:65
msgid "Road Carrier add error: "
msgstr "Road Carrier add error: "

#: src/timber/hooks/useRoadCarrier.ts:131
msgid "Road Carrier delete error: "
msgstr "Road Carrier delete error: "

#: src/timber/hooks/useRoadCarrier.ts:128
msgid "Road Carrier deleted"
msgstr "Road Carrier deleted"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:271
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:184
#~ msgid "Road Carrier Id is required"
#~ msgstr "Road Carrier Id is required"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:353
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:404
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:193
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:244
msgid "Road Carrier is required"
msgstr "Road Carrier is required"

#: src/timber/hooks/useRoadCarrier.ts:98
msgid "Road Carrier update error: "
msgstr "Road Carrier update error: "

#: src/timber/hooks/useRoadCarrier.ts:95
msgid "Road Carrier updated"
msgstr "Road Carrier updated"

#: src/app/mappers.tsx:216
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListHeader.tsx:43
#: src/timber/pages/listItems.tsx:97
msgid "Road Carriers"
msgstr "Road Carriers"

#: src/auth/components/role/RoleDetail/RoleDetail.tsx:36
#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx:73
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:133
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx:260
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx:349
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx:319
#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx:63
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx:93
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItem.tsx:204
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx:223
#: src/auth/pages/role/RoleEntityPage.tsx:17
msgid "Role"
msgstr "Role"

#: src/auth/hooks/useRole.ts:65
msgid "Role add error: "
msgstr "Role add error: "

#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx:42
#: src/auth/pages/roleAssignment/RoleAssignmentEntityPage.tsx:17
msgid "Role Assignment"
msgstr "Role Assignment"

#: src/auth/hooks/useRoleAssignment.ts:60
msgid "Role Assignment add error: "
msgstr "Role Assignment add error: "

#: src/auth/hooks/useRoleAssignment.ts:95
msgid "Role Assignment delete error: "
msgstr "Role Assignment delete error: "

#: src/auth/hooks/useRoleAssignment.ts:92
msgid "Role Assignment deleted"
msgstr "Role Assignment deleted"

#: src/app/mappers.tsx:205
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx:61
#: src/auth/components/role/RoleDetail/RoleTabs.tsx:45
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListHeader.tsx:46
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupTabs.tsx:41
msgid "Role Assignments"
msgstr "Role Assignments"

#: src/auth/hooks/useRole.ts:131
msgid "Role delete error: "
msgstr "Role delete error: "

#: src/auth/hooks/useRole.ts:128
msgid "Role deleted"
msgstr "Role deleted"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:72
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:73
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx:48
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx:49
#~ msgid "Role Id is required"
#~ msgstr "Role Id is required"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:96
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:97
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx:70
#: src/auth/components/rolePermission/RolePermissionForm/RolePermissionAddForm.tsx:71
msgid "Role is required"
msgstr "Role is required"

#: src/auth/components/rolePermission/RolePermissionDetail/RolePermissionDetail.tsx:36
#: src/auth/pages/rolePermission/RolePermissionEntityPage.tsx:17
msgid "Role Permission"
msgstr "Role Permission"

#: src/auth/hooks/useRolePermission.ts:60
msgid "Role Permission add error: "
msgstr "Role Permission add error: "

#: src/auth/hooks/useRolePermission.ts:95
msgid "Role Permission delete error: "
msgstr "Role Permission delete error: "

#: src/auth/hooks/useRolePermission.ts:92
msgid "Role Permission deleted"
msgstr "Role Permission deleted"

#: src/app/mappers.tsx:202
#: src/auth/components/role/RoleDetail/RoleTabs.tsx:42
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListHeader.tsx:44
msgid "Role Permissions"
msgstr "Role Permissions"

#: src/auth/hooks/useRole.ts:98
msgid "Role update error: "
msgstr "Role update error: "

#: src/auth/hooks/useRole.ts:95
msgid "Role updated"
msgstr "Role updated"

#: src/app/mappers.tsx:201
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx:52
#: src/auth/components/role/RoleList/RoleListHeader.tsx:44
#: src/auth/pages/listItems.tsx:50
msgid "Roles"
msgstr "Roles"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:741
msgid "Row Total"
msgstr "Row Total"

#: src/address/components/address/AddressList/AddressListPagination.tsx:26
#: src/address/components/userAddress/UserAddressList/UserAddressListPagination.tsx:26
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListPagination.tsx:26
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListPagination.tsx:26
#: src/auth/components/role/RoleList/RoleListPagination.tsx:26
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListPagination.tsx:26
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListPagination.tsx:26
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListPagination.tsx:26
#: src/auth/components/user/UserList/UserListPagination.tsx:26
#: src/auth/components/userSession/UserSessionList/UserSessionListPagination.tsx:26
#: src/location/components/location/LocationList/LocationListPagination.tsx:26
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListPagination.tsx:26
#: src/timber/components/buyer/BuyerList/BuyerListPagination.tsx:26
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListPagination.tsx:26
#: src/timber/components/contractor/ContractorList/ContractorListPagination.tsx:26
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListPagination.tsx:26
#: src/timber/components/cordwood/CordwoodList/CordwoodListPagination.tsx:26
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListPagination.tsx:26
#: src/timber/components/cutting/CuttingList/CuttingListPagination.tsx:26
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListPagination.tsx:26
#: src/timber/components/generic/report/GenericRootShipments.tsx:553
#: src/timber/components/log/LogList/LogListPagination.tsx:26
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListPagination.tsx:26
#: src/timber/components/price/PriceList/PriceListPagination.tsx:26
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListPagination.tsx:26
#: src/timber/components/provider/ProviderList/ProviderListPagination.tsx:26
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListPagination.tsx:26
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListPagination.tsx:26
#: src/timber/components/shipment/ShipmentList/ShipmentListPagination.tsx:26
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListPagination.tsx:26
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListPagination.tsx:26
#: src/timber/components/timberClass/TimberClassList/TimberClassListPagination.tsx:26
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListPagination.tsx:26
#: src/timber/components/timberType/TimberTypeList/TimberTypeListPagination.tsx:26
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListPagination.tsx:26
msgid "rows per page"
msgstr "rows per page"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:952
msgid "Save"
msgstr "Save"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:709
msgid "Save as new profile"
msgstr "Save as new profile"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:706
msgid "Save changes to selected profile"
msgstr "Save changes to selected profile"

#: src/auth/components/role/RoleDetail/RoleDetail.tsx:65
#: src/auth/components/role/RoleForm/RoleAddForm.tsx:134
#: src/auth/components/role/RoleForm/RoleUpdateForm.tsx:93
#: src/auth/components/role/RoleList/RoleListItem.tsx:314
#: src/auth/components/role/RoleList/RoleListSearch.tsx:262
msgid "Scope"
msgstr "Scope"

#: src/auth/components/roleAssignment/RoleAssignmentDetail/RoleAssignmentDetail.tsx:77
#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:147
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItem.tsx:364
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx:351
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx:36
#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx:75
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx:333
#: src/auth/pages/scopeGroup/ScopeGroupEntityPage.tsx:17
msgid "Scope Group"
msgstr "Scope Group"

#: src/auth/hooks/useScopeGroup.ts:65
msgid "Scope Group add error: "
msgstr "Scope Group add error: "

#: src/auth/components/scopeGroup/ScopeGroupDetail/ScopeGroupDetail.tsx:68
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:159
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx:93
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItem.tsx:315
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx:260
msgid "Scope Group Context"
msgstr "Scope Group Context"

#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupAddForm.tsx:109
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateForm.tsx:55
msgid "Scope Group Context is required"
msgstr "Scope Group Context is required"

#: src/auth/hooks/useScopeGroup.ts:131
msgid "Scope Group delete error: "
msgstr "Scope Group delete error: "

#: src/auth/hooks/useScopeGroup.ts:128
msgid "Scope Group deleted"
msgstr "Scope Group deleted"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:79
#~ msgid "Scope Group Id is required"
#~ msgstr "Scope Group Id is required"

#: src/auth/components/roleAssignment/RoleAssignmentForm/RoleAssignmentAddForm.tsx:102
msgid "Scope Group is required"
msgstr "Scope Group is required"

#: src/auth/hooks/useScopeGroup.ts:98
msgid "Scope Group update error: "
msgstr "Scope Group update error: "

#: src/auth/hooks/useScopeGroup.ts:95
msgid "Scope Group updated"
msgstr "Scope Group updated"

#: src/app/mappers.tsx:204
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx:58
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListHeader.tsx:44
#: src/auth/pages/listItems.tsx:63
msgid "Scope Groups"
msgstr "Scope Groups"

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx:337
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx:325
#: src/auth/components/role/RoleList/RoleListSearch.tsx:321
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx:388
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx:270
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx:314
#: src/location/components/location/LocationList/LocationListSearch.tsx:313
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:506
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx:328
#: src/timber/components/log/LogList/LogListSearch.tsx:619
#: src/timber/components/price/PriceList/PriceListSearch.tsx:326
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:451
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx:279
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx:343
msgid "Search"
msgstr "Search"

#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListSearch.tsx:65
#~ msgid "Search (by Cordwood Id, Action)"
#~ msgstr "Search (by Cordwood Id, Action)"

#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListSearch.tsx:65
msgid "Search (by Cordwood, Action)"
msgstr "Search (by Cordwood, Action)"

#: src/address/components/address/AddressList/AddressListSearch.tsx:65
msgid "Search (by Email, Address, City)"
msgstr "Search (by Email, Address, City)"

#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListSearch.tsx:65
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListSearch.tsx:65
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListSearch.tsx:65
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListSearch.tsx:65
msgid "Search (by Email, Name)"
msgstr "Search (by Email, Name)"

#: src/auth/components/user/UserList/UserListSearch.tsx:65
msgid "Search (by Email)"
msgstr "Search (by Email)"

#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListSearch.tsx:192
#: src/location/components/location/LocationList/LocationListSearch.tsx:183
msgid "Search (by Hierarchy Name)"
msgstr "Search (by Hierarchy Name)"

#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:252
msgid "Search (by Key, Report Key, Shipment At)"
msgstr "Search (by Key, Report Key, Shipment At)"

#: src/timber/components/logHistory/LogHistoryList/LogHistoryListSearch.tsx:65
#~ msgid "Search (by Log Id, Action)"
#~ msgstr "Search (by Log Id, Action)"

#: src/timber/components/logHistory/LogHistoryList/LogHistoryListSearch.tsx:65
msgid "Search (by Log, Action)"
msgstr "Search (by Log, Action)"

#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx:200
msgid "Search (by Member Group, Owner Member Group)"
msgstr "Search (by Member Group, Owner Member Group)"

#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx:226
msgid "Search (by Member Group, Role)"
msgstr "Search (by Member Group, Role)"

#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx:202
#~ msgid "Search (by Members Group Id, Owned Members Group Id)"
#~ msgstr "Search (by Members Group Id, Owned Members Group Id)"

#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListSearch.tsx:230
#~ msgid "Search (by Members Group Id, Role Id)"
#~ msgstr "Search (by Members Group Id, Role Id)"

#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListSearch.tsx:65
#~ msgid "Search (by Name, Class Id)"
#~ msgstr "Search (by Name, Class Id)"

#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListSearch.tsx:65
msgid "Search (by Name, Timber Class)"
msgstr "Search (by Name, Timber Class)"

#: src/auth/components/role/RoleList/RoleListSearch.tsx:186
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListSearch.tsx:184
#: src/timber/components/buyer/BuyerList/BuyerListSearch.tsx:65
#: src/timber/components/contractor/ContractorList/ContractorListSearch.tsx:65
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx:196
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListSearch.tsx:65
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListSearch.tsx:65
#: src/timber/components/provider/ProviderList/ProviderListSearch.tsx:65
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListSearch.tsx:65
#: src/timber/components/timberClass/TimberClassList/TimberClassListSearch.tsx:65
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListSearch.tsx:178
#: src/timber/components/timberType/TimberTypeList/TimberTypeListSearch.tsx:65
msgid "Search (by Name)"
msgstr "Search (by Name)"

#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx:164
#~ msgid "Search (by Role Id, Permission)"
#~ msgstr "Search (by Role Id, Permission)"

#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListSearch.tsx:164
msgid "Search (by Role, Permission)"
msgstr "Search (by Role, Permission)"

#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListSearch.tsx:65
#~ msgid "Search (by Shipment Id, Action)"
#~ msgstr "Search (by Shipment Id, Action)"

#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListSearch.tsx:65
msgid "Search (by Shipment, Action)"
msgstr "Search (by Shipment, Action)"

#: src/timber/components/log/LogList/LogListSearch.tsx:303
msgid "Search (by Timber Key, External Key, IK)"
msgstr "Search (by Timber Key, External Key, IK)"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:265
msgid "Search (by Timber Key, IK)"
msgstr "Search (by Timber Key, IK)"

#: src/timber/components/price/PriceList/PriceListSearch.tsx:204
#~ msgid "Search (by Timber Type Id, Class Id, Thickness Class Id)"
#~ msgstr "Search (by Timber Type Id, Class Id, Thickness Class Id)"

#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx:204
#~ msgid "Search (by Timber Type Id, Volume (m&#xB3;))"
#~ msgstr "Search (by Timber Type Id, Volume (m&#xB3;))"

#: src/timber/components/price/PriceList/PriceListSearch.tsx:204
msgid "Search (by Timber Type, Timber Class, Thickness Class)"
msgstr "Search (by Timber Type, Timber Class, Thickness Class)"

#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx:203
msgid "Search (by Timber Type, Volume (m&#xB3;))"
msgstr "Search (by Timber Type, Volume (m&#xB3;))"

#: src/address/components/userAddress/UserAddressList/UserAddressListSearch.tsx:65
#~ msgid "Search (by User Id, Address Id)"
#~ msgstr "Search (by User Id, Address Id)"

#: src/auth/components/userSession/UserSessionList/UserSessionListSearch.tsx:65
#~ msgid "Search (by User Id)"
#~ msgstr "Search (by User Id)"

#: src/address/components/userAddress/UserAddressList/UserAddressListSearch.tsx:65
msgid "Search (by User, Address)"
msgstr "Search (by User, Address)"

#: src/auth/components/userSession/UserSessionList/UserSessionListSearch.tsx:65
msgid "Search (by User)"
msgstr "Search (by User)"

#: src/share/components/gdpr/CookieConsent.tsx:36
msgid "See our"
msgstr "See our"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:334
msgid "Select cordwood to shipment"
msgstr "Select cordwood to shipment"

#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:315
msgid "Select log for shipment"
msgstr "Select log for shipment"

#: src/timber/components/shipment/ShipmentRegulator/LogShipmentUpload.tsx:74
msgid "Select shipment CSV file"
msgstr "Select shipment CSV file"

#: src/share/components/scope/ScopeSwitcher.tsx:39
msgid "Selected Group"
msgstr "Selected Group"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:120
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:116
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:56
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:300
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:701
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:466
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:116
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:217
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:574
#: src/timber/components/log/LogDetail/LogDetail.tsx:136
#: src/timber/components/log/LogForm/LogAddForm.tsx:131
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:59
#: src/timber/components/log/LogList/LogListItem.tsx:308
#: src/timber/components/log/LogList/LogListItem.tsx:816
#: src/timber/components/log/LogList/LogListSearch.tsx:579
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:122
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:219
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:593
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:55
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:87
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:90
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:76
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx:140
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:189
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:374
#: src/timber/pages/shipment/ShipmentEntityPage.tsx:17
msgid "Shipment"
msgstr "Shipment"

#: src/timber/hooks/useShipment.ts:65
msgid "Shipment add error: "
msgstr "Shipment add error: "

#: src/timber/components/generic/report/GenericRootShipments.tsx:402
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:95
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:466
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:288
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:592
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:95
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:481
msgid "Shipment At"
msgstr "Shipment At"

#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:346
msgid "Shipment At From"
msgstr "Shipment At From"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:398
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:238
msgid "Shipment at is required"
msgstr "Shipment at is required"

#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:347
msgid "Shipment At To"
msgstr "Shipment At To"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:300
msgid "Shipment Cordwood"
msgstr "Shipment Cordwood"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx:81
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:280
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:186
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx:219
msgid "Shipment Cordwood Code"
msgstr "Shipment Cordwood Code"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:170
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:97
msgid "Shipment Cordwood Code is required"
msgstr "Shipment Cordwood Code is required"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx:84
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:295
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:201
msgid "Shipment Cordwood Counter"
msgstr "Shipment Cordwood Counter"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:176
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:103
msgid "Shipment Cordwood Counter is required"
msgstr "Shipment Cordwood Counter is required"

#: src/timber/hooks/useShipment.ts:131
msgid "Shipment delete error: "
msgstr "Shipment delete error: "

#: src/timber/hooks/useShipment.ts:128
msgid "Shipment deleted"
msgstr "Shipment deleted"

#: src/app/mappers.tsx:231
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx:95
#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx:168
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListHeader.tsx:44
msgid "Shipment Histories"
msgstr "Shipment Histories"

#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:49
#: src/timber/pages/shipmentHistory/ShipmentHistoryEntityPage.tsx:17
msgid "Shipment History"
msgstr "Shipment History"

#: src/timber/hooks/useShipmentHistory.ts:60
msgid "Shipment History add error: "
msgstr "Shipment History add error: "

#: src/timber/hooks/useShipmentHistory.ts:95
msgid "Shipment History delete error: "
msgstr "Shipment History delete error: "

#: src/timber/hooks/useShipmentHistory.ts:92
msgid "Shipment History deleted"
msgstr "Shipment History deleted"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:181
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:117
#: src/timber/components/log/LogForm/LogAddForm.tsx:242
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:166
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx:79
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx:80
#~ msgid "Shipment Id is required"
#~ msgstr "Shipment Id is required"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:250
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:155
#: src/timber/components/log/LogForm/LogAddForm.tsx:293
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:186
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx:111
#: src/timber/components/shipmentHistory/ShipmentHistoryForm/ShipmentHistoryAddForm.tsx:112
msgid "Shipment is required"
msgstr "Shipment is required"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx:75
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:250
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:156
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx:202
msgid "Shipment Log Code"
msgstr "Shipment Log Code"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:158
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:85
msgid "Shipment Log Code is required"
msgstr "Shipment Log Code is required"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx:78
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:265
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:171
msgid "Shipment Log Counter"
msgstr "Shipment Log Counter"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:164
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:91
msgid "Shipment Log Counter is required"
msgstr "Shipment Log Counter is required"

#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:281
msgid "Shipment Logs"
msgstr "Shipment Logs"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:141
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:667
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:462
msgid "Shipment Order"
msgstr "Shipment Order"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:544
#: src/timber/components/generic/report/GenericRootReport.tsx:246
#: src/timber/components/generic/report/TimelineRootReport.tsx:315
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:125
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:594
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:285
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:659
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:403
msgid "Shipment Type"
msgstr "Shipment Type"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:348
msgid "Shipment Type is required"
msgstr "Shipment Type is required"

#: src/timber/hooks/useShipment.ts:98
msgid "Shipment update error: "
msgstr "Shipment update error: "

#: src/timber/hooks/useShipment.ts:95
msgid "Shipment updated"
msgstr "Shipment updated"

#: src/app/mappers.tsx:225
#: src/location/components/location/LocationDetail/LocationTabs.tsx:49
#: src/timber/components/buyer/BuyerDetail/BuyerTabs.tsx:58
#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserTabs.tsx:41
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:63
#: src/timber/components/roadCarrier/RoadCarrierDetail/RoadCarrierTabs.tsx:41
#: src/timber/components/shipment/ShipmentList/ShipmentListHeader.tsx:53
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx:60
msgid "Shipments"
msgstr "Shipments"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:121
msgid "Shipping Contractor User"
msgstr "Shipping Contractor User"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:214
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:215
#~ msgid "Shipping Contractor User Id is required"
#~ msgstr "Shipping Contractor User Id is required"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:299
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:300
msgid "Shipping Contractor User is required"
msgstr "Shipping Contractor User is required"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:492
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:300
msgid "Source Location"
msgstr "Source Location"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:221
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:139
#~ msgid "Source Location Id is required"
#~ msgstr "Source Location Id is required"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:305
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:151
msgid "Source Location is required"
msgstr "Source Location is required"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:106
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:507
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:315
msgid "Source Parcel"
msgstr "Source Parcel"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx:81
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:243
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:169
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx:349
msgid "Start At"
msgstr "Start At"

#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx:316
msgid "Start At From"
msgstr "Start At From"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:162
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:100
msgid "Start At is required"
msgstr "Start At is required"

#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx:317
msgid "Start At To"
msgstr "Start At To"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:197
msgid "Start Date"
msgstr "Start Date"

#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:122
#: src/timber/components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryAddForm.tsx:213
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:345
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:609
#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx:78
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:229
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:155
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx:274
#: src/timber/components/cutting/CuttingList/CuttingListItem.tsx:332
#: src/timber/components/cutting/CuttingList/CuttingListSearch.tsx:272
#: src/timber/components/generic/report/GenericRootShipments.tsx:328
#: src/timber/components/generic/report/GenericRootShipments.tsx:427
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:125
#: src/timber/components/logHistory/LogHistoryForm/LogHistoryAddForm.tsx:225
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:347
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:611
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:122
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:581
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:389
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:302
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:442
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:642
#: src/timber/components/shipment/ShipmentList/ShipmentListSearch.tsx:387
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:106
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:206
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:521
msgid "State"
msgstr "State"

#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:156
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:94
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:342
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:188
msgid "State is required"
msgstr "State is required"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:377
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:581
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:732
#: src/timber/components/generic/report/GenericRootReport.tsx:284
#: src/timber/components/generic/report/GenericRootTable.tsx:125
#: src/timber/components/generic/report/TimelineRootReport.tsx:348
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:391
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:418
#: src/timber/components/log/LogForm/LogAddForm.tsx:469
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:451
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:100
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:114
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:66
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:115
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:121
msgid "Storage"
msgstr "Storage"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:172
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:173
#: src/timber/components/log/LogForm/LogAddForm.tsx:233
#: src/timber/components/log/LogForm/LogAddForm.tsx:234
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:201
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:202
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:66
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:67
#~ msgid "Storage Id is required"
#~ msgstr "Storage Id is required"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:244
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:245
#: src/timber/components/log/LogForm/LogAddForm.tsx:287
#: src/timber/components/log/LogForm/LogAddForm.tsx:288
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:287
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:288
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:92
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:93
msgid "Storage is required"
msgstr "Storage is required"

#: src/timber/components/shipment/ShipmentRegulator/LogShipmentUpload.tsx:89
msgid "Submit"
msgstr "Submit"

#: src/share/components/alert/DescriptionAlert/useDescriptionAlert.ts:24
msgid "Success"
msgstr "Success"

#: src/app/App.tsx:67
msgid "Swagger UI"
msgstr "Swagger UI"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx:80
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx:239
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx:199
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx:80
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx:239
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx:199
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx:80
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx:236
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx:199
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx:80
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx:236
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx:199
msgid "Swift"
msgstr "Swift"

#: src/pages/PreferencesPage.tsx:89
msgid "System"
msgstr "System"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:113
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:537
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:345
msgid "Target Address"
msgstr "Target Address"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:116
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:552
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:360
msgid "Target City"
msgstr "Target City"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:119
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:567
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:375
msgid "Target Country"
msgstr "Target Country"

#: src/timber/components/log/LogList/LogListItem.tsx:524
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:504
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:200
msgid "TC"
msgstr "TC"

#: src/app/App.tsx:129
#: src/pages/LoginPage.tsx:226
msgid "Terms"
msgstr "Terms"

#: src/pages/PrivacyPolicyPage.tsx:32
#: src/pages/TermsPage.tsx:10
msgid "Terms of Service"
msgstr "Terms of Service"

#: src/pages/TermsPage.tsx:19
msgid "The service is provided “as is”. We may modify these terms from time to time. Continued use constitutes acceptance of the updated terms."
msgstr "The service is provided “as is”. We may modify these terms from time to time. Continued use constitutes acceptance of the updated terms."

#: src/pages/PreferencesPage.tsx:79
msgid "Theme"
msgstr "Theme"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:735
#: src/timber/components/generic/report/GenericRootTable.tsx:129
#: src/timber/components/log/LogDetail/LogDetail.tsx:108
#: src/timber/components/log/LogList/LogListItem.tsx:717
#: src/timber/components/log/LogList/LogListSearch.tsx:547
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:143
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:707
#: src/timber/components/price/PriceDetail/PriceDetail.tsx:88
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:196
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:141
#: src/timber/components/price/PriceList/PriceListItem.tsx:262
#: src/timber/components/price/PriceList/PriceListSearch.tsx:303
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:112
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:390
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:102
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx:40
#: src/timber/pages/thicknessClass/ThicknessClassEntityPage.tsx:17
msgid "Thickness Class"
msgstr "Thickness Class"

#: src/timber/hooks/useThicknessClass.ts:65
msgid "Thickness Class add error: "
msgstr "Thickness Class add error: "

#: src/timber/hooks/useThicknessClass.ts:131
msgid "Thickness Class delete error: "
msgstr "Thickness Class delete error: "

#: src/timber/hooks/useThicknessClass.ts:128
msgid "Thickness Class deleted"
msgstr "Thickness Class deleted"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx:105
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:74
#~ msgid "Thickness Class Id is required"
#~ msgstr "Thickness Class Id is required"

#: src/timber/components/price/PriceForm/PriceAddForm.tsx:131
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:90
msgid "Thickness Class is required"
msgstr "Thickness Class is required"

#: src/timber/hooks/useThicknessClass.ts:98
msgid "Thickness Class update error: "
msgstr "Thickness Class update error: "

#: src/timber/hooks/useThicknessClass.ts:95
msgid "Thickness Class updated"
msgstr "Thickness Class updated"

#: src/app/mappers.tsx:210
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListHeader.tsx:43
#: src/timber/pages/listItems.tsx:37
msgid "Thickness Classes"
msgstr "Thickness Classes"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:224
msgid "This Month"
msgstr "This Month"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:214
msgid "This Week"
msgstr "This Week"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:234
msgid "This Year"
msgstr "This Year"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:101
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:350
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:234
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:638
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:434
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:133
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:667
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:635
#: src/timber/components/generic/report/GenericRootReport.tsx:337
#: src/timber/components/generic/report/TimelineRootReport.tsx:396
#: src/timber/components/log/LogDetail/LogDetail.tsx:104
#: src/timber/components/log/LogForm/LogAddForm.tsx:397
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:269
#: src/timber/components/log/LogList/LogListItem.tsx:696
#: src/timber/components/log/LogList/LogListSearch.tsx:515
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:139
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:686
#: src/timber/components/price/PriceDetail/PriceDetail.tsx:84
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:182
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:127
#: src/timber/components/price/PriceList/PriceListItem.tsx:241
#: src/timber/components/price/PriceList/PriceListSearch.tsx:283
#: src/timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail.tsx:85
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:260
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:226
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItem.tsx:207
#: src/timber/components/timberClass/TimberClassDetail/TimberClassDetail.tsx:37
#: src/timber/pages/timberClass/TimberClassEntityPage.tsx:17
msgid "Timber Class"
msgstr "Timber Class"

#: src/timber/hooks/useTimberClass.ts:65
msgid "Timber Class add error: "
msgstr "Timber Class add error: "

#: src/timber/hooks/useTimberClass.ts:131
msgid "Timber Class delete error: "
msgstr "Timber Class delete error: "

#: src/timber/hooks/useTimberClass.ts:128
msgid "Timber Class deleted"
msgstr "Timber Class deleted"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:233
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:234
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:144
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:145
#: src/timber/components/log/LogForm/LogAddForm.tsx:260
#: src/timber/components/log/LogForm/LogAddForm.tsx:261
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:159
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:160
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:125
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:126
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:84
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:85
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassAddForm.tsx:149
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm.tsx:115
msgid "Timber Class is required"
msgstr "Timber Class is required"

#: src/timber/hooks/useTimberClass.ts:98
msgid "Timber Class update error: "
msgstr "Timber Class update error: "

#: src/timber/hooks/useTimberClass.ts:95
msgid "Timber Class updated"
msgstr "Timber Class updated"

#: src/app/mappers.tsx:209
#: src/timber/components/timberClass/TimberClassList/TimberClassListHeader.tsx:43
#: src/timber/pages/listItems.tsx:24
msgid "Timber Classes"
msgstr "Timber Classes"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:84
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:292
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:229
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:546
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:341
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:100
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:518
#: src/timber/components/log/LogDetail/LogDetail.tsx:87
#: src/timber/components/log/LogForm/LogAddForm.tsx:335
#: src/timber/components/log/LogList/LogListItem.tsx:235
#: src/timber/components/log/LogList/LogListItem.tsx:604
#: src/timber/components/log/LogList/LogListSearch.tsx:379
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:103
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:520
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:387
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:403
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:89
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:95
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:368
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:384
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:90
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:96
msgid "Timber Key"
msgstr "Timber Key"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:210
#: src/timber/components/log/LogForm/LogAddForm.tsx:237
msgid "Timber Key is required"
msgstr "Timber Key is required"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:108
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:676
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:104
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:538
#: src/timber/components/generic/report/GenericRootShipments.tsx:387
#: src/timber/components/log/LogDetail/LogDetail.tsx:124
#: src/timber/components/log/LogList/LogListItem.tsx:791
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:110
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:557
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:92
#: src/timber/components/shipment/ShipmentList/ShipmentListItem.tsx:574
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:92
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:463
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageDetail.tsx:46
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx:77
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx:333
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx:323
#: src/timber/pages/timberStorage/TimberStorageEntityPage.tsx:17
msgid "Timber Storage"
msgstr "Timber Storage"

#: src/timber/hooks/useTimberStorage.ts:65
msgid "Timber Storage add error: "
msgstr "Timber Storage add error: "

#: src/timber/hooks/useTimberStorage.ts:131
msgid "Timber Storage delete error: "
msgstr "Timber Storage delete error: "

#: src/timber/hooks/useTimberStorage.ts:128
msgid "Timber Storage deleted"
msgstr "Timber Storage deleted"

#: src/timber/hooks/useTimberStorage.ts:98
msgid "Timber Storage update error: "
msgstr "Timber Storage update error: "

#: src/timber/hooks/useTimberStorage.ts:95
msgid "Timber Storage updated"
msgstr "Timber Storage updated"

#: src/app/mappers.tsx:224
#: src/location/components/location/LocationDetail/LocationTabs.tsx:46
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:60
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerTabs.tsx:61
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListHeader.tsx:51
msgid "Timber Storages"
msgstr "Timber Storages"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:97
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:336
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:220
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:277
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:617
#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:402
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:129
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:646
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:609
#: src/timber/components/generic/report/GenericRootReport.tsx:312
#: src/timber/components/generic/report/TimelineRootReport.tsx:373
#: src/timber/components/log/LogDetail/LogDetail.tsx:100
#: src/timber/components/log/LogForm/LogAddForm.tsx:383
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:255
#: src/timber/components/log/LogList/LogListItem.tsx:285
#: src/timber/components/log/LogList/LogListItem.tsx:675
#: src/timber/components/log/LogList/LogListSearch.tsx:483
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:135
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:665
#: src/timber/components/price/PriceDetail/PriceDetail.tsx:80
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:168
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:113
#: src/timber/components/price/PriceList/PriceListItem.tsx:220
#: src/timber/components/price/PriceList/PriceListSearch.tsx:263
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:94
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:389
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:405
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:91
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:97
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:106
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:370
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:388
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:92
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:100
#: src/timber/components/timberType/TimberTypeDetail/TimberTypeDetail.tsx:37
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx:81
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:135
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx:219
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx:354
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx:291
#: src/timber/pages/timberType/TimberTypeEntityPage.tsx:17
msgid "Timber Type"
msgstr "Timber Type"

#: src/timber/hooks/useTimberType.ts:65
msgid "Timber Type add error: "
msgstr "Timber Type add error: "

#: src/timber/hooks/useTimberType.ts:131
msgid "Timber Type delete error: "
msgstr "Timber Type delete error: "

#: src/timber/hooks/useTimberType.ts:128
msgid "Timber Type deleted"
msgstr "Timber Type deleted"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:152
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:153
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:94
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:95
#: src/timber/components/log/LogForm/LogAddForm.tsx:194
#: src/timber/components/log/LogForm/LogAddForm.tsx:195
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:124
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:125
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:91
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:92
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:60
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:61
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:73
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:74
#~ msgid "Timber Type Id is required"
#~ msgstr "Timber Type Id is required"

#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:227
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:228
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:138
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:139
#: src/timber/components/log/LogForm/LogAddForm.tsx:254
#: src/timber/components/log/LogForm/LogAddForm.tsx:255
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:153
#: src/timber/components/log/LogForm/LogUpdateForm.tsx:154
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:119
#: src/timber/components/price/PriceForm/PriceAddForm.tsx:120
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:78
#: src/timber/components/price/PriceForm/PriceUpdateForm.tsx:79
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:98
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:99
msgid "Timber Type is required"
msgstr "Timber Type is required"

#: src/timber/hooks/useTimberType.ts:98
msgid "Timber Type update error: "
msgstr "Timber Type update error: "

#: src/timber/hooks/useTimberType.ts:95
msgid "Timber Type updated"
msgstr "Timber Type updated"

#: src/app/mappers.tsx:211
#: src/timber/components/timberType/TimberTypeList/TimberTypeListHeader.tsx:43
#: src/timber/pages/listItems.tsx:50
msgid "Timber Types"
msgstr "Timber Types"

#: src/timber/pages/listItems.tsx:209
msgid "Timberstorage"
msgstr "Timberstorage"

#: src/timber/components/contractor/ContractorDetail/ContractorTabs.tsx:97
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:90
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx:87
msgid "Timeline Report"
msgstr "Timeline Report"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:670
#: src/timber/components/generic/report/GenericRootReport.tsx:371
#: src/timber/components/generic/report/TimelineRootReport.tsx:422
#~ msgid "To Input Date"
#~ msgstr "To Input Date"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:683
#: src/timber/components/generic/report/GenericRootReport.tsx:384
#: src/timber/components/generic/report/TimelineRootReport.tsx:428
msgid "To Shipment Date"
msgstr "To Shipment Date"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:670
#: src/timber/components/generic/report/GenericRootReport.tsx:371
#: src/timber/components/generic/report/TimelineRootReport.tsx:422
msgid "To Timber Input Date"
msgstr "To Timber Input Date"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:204
msgid "Today"
msgstr "Today"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:904
#: src/timber/components/generic/report/GenericRootTable.tsx:285
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:451
msgid "Total"
msgstr "Total"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:844
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:867
#: src/timber/components/generic/report/GenericRootTable.tsx:221
#: src/timber/components/generic/report/GenericRootTable.tsx:243
msgid "Total class and type"
msgstr "Total class and type"

#: src/timber/components/generic/report/GenericRootShipments.tsx:54
msgid "Total Logs"
msgstr "Total Logs"

#: src/timber/components/generic/report/GenericRootTable.tsx:271
msgid "Total on cutting"
msgstr "Total on cutting"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:887
#: src/timber/components/generic/report/GenericRootTable.tsx:256
msgid "Total on storage"
msgstr "Total on storage"

#: src/timber/components/generic/report/GenericRootShipments.tsx:53
#: src/timber/components/generic/report/GenericRootShipments.tsx:92
msgid "Total Shipments"
msgstr "Total Shipments"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:423
msgid "Total volume"
msgstr "Total volume"

#: src/timber/components/generic/report/GenericRootShipments.tsx:55
#: src/timber/components/generic/report/GenericRootShipments.tsx:93
msgid "Total Volume"
msgstr "Total Volume"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:400
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:471
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx:46
#: src/timber/pages/treeMarking/TreeMarkingEntityPage.tsx:17
msgid "Tree Marking"
msgstr "Tree Marking"

#: src/timber/hooks/useTreeMarking.ts:65
msgid "Tree Marking add error: "
msgstr "Tree Marking add error: "

#: src/timber/hooks/useTreeMarking.ts:131
msgid "Tree Marking delete error: "
msgstr "Tree Marking delete error: "

#: src/timber/hooks/useTreeMarking.ts:128
msgid "Tree Marking deleted"
msgstr "Tree Marking deleted"

#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:87
msgid "Tree Marking Report"
msgstr "Tree Marking Report"

#: src/timber/hooks/useTreeMarking.ts:98
msgid "Tree Marking update error: "
msgstr "Tree Marking update error: "

#: src/timber/hooks/useTreeMarking.ts:95
msgid "Tree Marking updated"
msgstr "Tree Marking updated"

#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:420
msgid "Tree Marking volume"
msgstr "Tree Marking volume"

#: src/app/mappers.tsx:228
#: src/timber/components/cutting/CuttingDetail/CuttingTabs.tsx:72
#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx:69
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListHeader.tsx:44
msgid "Tree Markings"
msgstr "Tree Markings"

#: src/timber/components/timberStorage/TimberStorageDetail/TimberStorageTabs.tsx:84
msgid "Tree Markings Report"
msgstr "Tree Markings Report"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:132
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:622
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:417
msgid "Truck Registration Number"
msgstr "Truck Registration Number"

#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:135
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:637
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:432
msgid "Trucker Name"
msgstr "Trucker Name"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:407
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:247
msgid "Trucker name at is required"
msgstr "Trucker name at is required"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:733
#: src/timber/components/generic/report/GenericRootTable.tsx:126
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:419
msgid "Type"
msgstr "Type"

#: src/pages/UnauthorizedPage.tsx:10
msgid "Unauthorized"
msgstr "Unauthorized"

#: src/pages/UnauthorizedPage.tsx:34
msgid "Unauthorized Page"
msgstr "Unauthorized Page"

#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:702
msgid "Unmatched rows"
msgstr "Unmatched rows"

#: src/timber/types/models/CuttingState.d.ts:24
#: src/timber/types/models/ShipmentState.d.ts:24
msgid "Upcoming"
msgstr "Upcoming"

#: src/address/components/address/AddressForm/AddressUpdateFormProvider.tsx:74
#: src/auth/components/membersGroup/MembersGroupForm/MembersGroupUpdateFormProvider.tsx:74
#: src/auth/components/role/RoleForm/RoleUpdateFormProvider.tsx:74
#: src/auth/components/scopeGroup/ScopeGroupForm/ScopeGroupUpdateFormProvider.tsx:74
#: src/auth/components/user/UserForm/UserUpdateFormProvider.tsx:74
#: src/auth/components/userSession/UserSessionForm/UserSessionUpdateFormProvider.tsx:74
#: src/location/components/location/LocationForm/LocationUpdateFormProvider.tsx:74
#: src/timber/components/accountingUser/AccountingUserForm/AccountingUserUpdateFormProvider.tsx:74
#: src/timber/components/buyer/BuyerForm/BuyerUpdateFormProvider.tsx:74
#: src/timber/components/buyerUser/BuyerUserForm/BuyerUserUpdateFormProvider.tsx:74
#: src/timber/components/contractor/ContractorForm/ContractorUpdateFormProvider.tsx:74
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateFormProvider.tsx:74
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateFormProvider.tsx:74
#: src/timber/components/cutting/CuttingForm/CuttingUpdateFormProvider.tsx:74
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateFormProvider.tsx:74
#: src/timber/components/log/LogForm/LogUpdateFormProvider.tsx:74
#: src/timber/components/price/PriceForm/PriceUpdateFormProvider.tsx:74
#: src/timber/components/pricingProfile/PricingProfileForm/PricingProfileUpdateFormProvider.tsx:74
#: src/timber/components/provider/ProviderForm/ProviderUpdateFormProvider.tsx:74
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateFormProvider.tsx:74
#: src/timber/components/roadCarrier/RoadCarrierForm/RoadCarrierUpdateFormProvider.tsx:74
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateFormProvider.tsx:85
#: src/timber/components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateFormProvider.tsx:74
#: src/timber/components/timberClass/TimberClassForm/TimberClassUpdateFormProvider.tsx:74
#: src/timber/components/timberStorage/TimberStorageForm/TimberStorageUpdateFormProvider.tsx:74
#: src/timber/components/timberType/TimberTypeForm/TimberTypeUpdateFormProvider.tsx:74
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingUpdateFormProvider.tsx:74
msgid "Update"
msgstr "Update"

#: src/timber/pages/accountingUser/AccountingUserUpdateEditPage.tsx:14
msgid "Update Accounting User"
msgstr "Update Accounting User"

#: src/address/pages/address/AddressUpdateEditPage.tsx:14
msgid "Update Address"
msgstr "Update Address"

#: src/timber/pages/buyer/BuyerUpdateEditPage.tsx:14
msgid "Update Buyer"
msgstr "Update Buyer"

#: src/timber/pages/buyerUser/BuyerUserUpdateEditPage.tsx:14
msgid "Update Buyer User"
msgstr "Update Buyer User"

#: src/timber/pages/contractor/ContractorUpdateEditPage.tsx:14
msgid "Update Contractor"
msgstr "Update Contractor"

#: src/timber/pages/contractorUser/ContractorUserUpdateEditPage.tsx:14
msgid "Update Contractor User"
msgstr "Update Contractor User"

#: src/timber/pages/cordwood/CordwoodUpdateEditPage.tsx:14
msgid "Update Cordwood"
msgstr "Update Cordwood"

#: src/timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage.tsx:14
msgid "Update Cordwood History"
msgstr "Update Cordwood History"

#: src/timber/pages/cutting/CuttingUpdateEditPage.tsx:14
msgid "Update Cutting"
msgstr "Update Cutting"

#: src/timber/pages/driver/DriverUpdateEditPage.tsx:21
#~ msgid "Update Driver"
#~ msgstr "Update Driver"

#: src/address/hooks/useAddress.ts:89
#: src/auth/hooks/useMembersGroup.ts:89
#: src/auth/hooks/useRole.ts:89
#: src/auth/hooks/useScopeGroup.ts:89
#: src/auth/hooks/useUser.ts:89
#: src/auth/hooks/useUserSession.ts:89
#: src/location/hooks/useLocation.ts:89
#: src/timber/hooks/useAccountingUser.ts:89
#: src/timber/hooks/useBuyer.ts:89
#: src/timber/hooks/useBuyerUser.ts:89
#: src/timber/hooks/useContractor.ts:89
#: src/timber/hooks/useContractorUser.ts:89
#: src/timber/hooks/useCordwood.ts:89
#: src/timber/hooks/useCutting.ts:89
#: src/timber/hooks/useForestOwner.ts:89
#: src/timber/hooks/useLog.ts:89
#: src/timber/hooks/usePrice.ts:89
#: src/timber/hooks/usePricingProfile.ts:89
#: src/timber/hooks/useProvider.ts:89
#: src/timber/hooks/useProviderUser.ts:89
#: src/timber/hooks/useRoadCarrier.ts:89
#: src/timber/hooks/useShipment.ts:89
#: src/timber/hooks/useThicknessClass.ts:89
#: src/timber/hooks/useTimberClass.ts:89
#: src/timber/hooks/useTimberStorage.ts:89
#: src/timber/hooks/useTimberType.ts:89
#: src/timber/hooks/useTreeMarking.ts:89
msgid "Update error: "
msgstr "Update error: "

#: src/timber/pages/forestOwner/ForestOwnerUpdateEditPage.tsx:14
msgid "Update Forest Owner"
msgstr "Update Forest Owner"

#: src/location/pages/location/LocationUpdateEditPage.tsx:14
msgid "Update Location"
msgstr "Update Location"

#: src/timber/pages/log/LogUpdateEditPage.tsx:14
msgid "Update Log"
msgstr "Update Log"

#: src/timber/pages/logHistory/LogHistoryUpdateEditPage.tsx:14
msgid "Update Log History"
msgstr "Update Log History"

#: src/auth/pages/membersGroup/MembersGroupUpdateEditPage.tsx:14
msgid "Update Members Group"
msgstr "Update Members Group"

#: src/auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage.tsx:14
msgid "Update Members Group User"
msgstr "Update Members Group User"

#: src/timber/pages/price/PriceUpdateEditPage.tsx:14
msgid "Update Price"
msgstr "Update Price"

#: src/timber/pages/pricingProfile/PricingProfileUpdateEditPage.tsx:14
msgid "Update Pricing Profile"
msgstr "Update Pricing Profile"

#: src/timber/pages/provider/ProviderUpdateEditPage.tsx:14
msgid "Update Provider"
msgstr "Update Provider"

#: src/timber/pages/providerUser/ProviderUserUpdateEditPage.tsx:14
msgid "Update Provider User"
msgstr "Update Provider User"

#: src/timber/pages/roadCarrier/RoadCarrierUpdateEditPage.tsx:14
msgid "Update Road Carrier"
msgstr "Update Road Carrier"

#: src/auth/pages/role/RoleUpdateEditPage.tsx:14
msgid "Update Role"
msgstr "Update Role"

#: src/auth/pages/roleAssignment/RoleAssignmentUpdateEditPage.tsx:14
msgid "Update Role Assignment"
msgstr "Update Role Assignment"

#: src/auth/pages/rolePermission/RolePermissionUpdateEditPage.tsx:14
msgid "Update Role Permission"
msgstr "Update Role Permission"

#: src/auth/pages/scopeGroup/ScopeGroupUpdateEditPage.tsx:14
msgid "Update Scope Group"
msgstr "Update Scope Group"

#: src/timber/pages/shipment/ShipmentUpdateEditPage.tsx:14
msgid "Update Shipment"
msgstr "Update Shipment"

#: src/timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage.tsx:14
msgid "Update Shipment History"
msgstr "Update Shipment History"

#: src/timber/pages/thicknessClass/ThicknessClassUpdateEditPage.tsx:14
msgid "Update Thickness Class"
msgstr "Update Thickness Class"

#: src/timber/pages/timberClass/TimberClassUpdateEditPage.tsx:14
msgid "Update Timber Class"
msgstr "Update Timber Class"

#: src/timber/pages/timberStorage/TimberStorageUpdateEditPage.tsx:14
msgid "Update Timber Storage"
msgstr "Update Timber Storage"

#: src/timber/pages/timberType/TimberTypeUpdateEditPage.tsx:14
msgid "Update Timber Type"
msgstr "Update Timber Type"

#: src/timber/pages/treeMarking/TreeMarkingUpdateEditPage.tsx:14
msgid "Update Tree Marking"
msgstr "Update Tree Marking"

#: src/auth/pages/user/UserUpdateEditPage.tsx:14
msgid "Update User"
msgstr "Update User"

#: src/address/pages/userAddress/UserAddressUpdateEditPage.tsx:14
msgid "Update User Address"
msgstr "Update User Address"

#: src/auth/pages/userSession/UserSessionUpdateEditPage.tsx:14
msgid "Update User Session"
msgstr "Update User Session"

#: src/auth/components/user/UserDetail/UserDetail.tsx:74
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx:79
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:94
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:234
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:484
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:97
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:236
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:486
#: src/timber/components/shipmentHistory/ShipmentHistoryDetail/ShipmentHistoryDetail.tsx:88
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:223
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItem.tsx:443
msgid "Updated At"
msgstr "Updated At"

#: src/timber/components/shipment/ShipmentDetail/ShipmentTabs.tsx:165
msgid "Upload"
msgstr "Upload"

#: src/timber/components/shipment/ShipmentRegulator/LogShipmentUpload.tsx:74
msgid "Upload file"
msgstr "Upload file"

#: src/address/components/userAddress/UserAddressDetail/UserAddressDetail.tsx:65
#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx:94
#: src/address/components/userAddress/UserAddressList/UserAddressListItem.tsx:164
#: src/auth/components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserDetail.tsx:70
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem.tsx:188
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListSearch.tsx:293
#: src/auth/components/user/UserDetail/UserDetail.tsx:36
#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx:66
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:129
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx:174
#: src/auth/components/userSession/UserSessionList/UserSessionListItem.tsx:305
#: src/auth/pages/user/UserEntityPage.tsx:17
msgid "User"
msgstr "User"

#: src/auth/hooks/useUser.ts:65
msgid "User add error: "
msgstr "User add error: "

#: src/address/components/userAddress/UserAddressDetail/UserAddressDetail.tsx:38
#: src/address/pages/userAddress/UserAddressEntityPage.tsx:17
msgid "User Address"
msgstr "User Address"

#: src/address/hooks/useUserAddress.ts:60
msgid "User Address add error: "
msgstr "User Address add error: "

#: src/address/hooks/useUserAddress.ts:95
msgid "User Address delete error: "
msgstr "User Address delete error: "

#: src/address/hooks/useUserAddress.ts:92
msgid "User Address deleted"
msgstr "User Address deleted"

#: src/address/components/userAddress/UserAddressList/UserAddressListHeader.tsx:44
#: src/app/mappers.tsx:196
#: src/auth/components/user/UserDetail/UserTabs.tsx:47
msgid "User Addresses"
msgstr "User Addresses"

#: src/auth/hooks/useUser.ts:131
msgid "User delete error: "
msgstr "User delete error: "

#: src/auth/hooks/useUser.ts:128
msgid "User deleted"
msgstr "User deleted"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:143
#: src/auth/types/models/GroupType.d.ts:27
msgid "User Group"
msgstr "User Group"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:76
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:77
#~ msgid "User Group Id is required"
#~ msgstr "User Group Id is required"

#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:100
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:101
msgid "User Group is required"
msgstr "User Group is required"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx:48
#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx:49
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:69
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:70
#~ msgid "User Id is required"
#~ msgstr "User Id is required"

#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx:71
#: src/address/components/userAddress/UserAddressForm/UserAddressAddForm.tsx:72
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:94
#: src/auth/components/userSession/UserSessionForm/UserSessionAddForm.tsx:95
msgid "User is required"
msgstr "User is required"

#: src/auth/components/userSession/UserSessionDetail/UserSessionDetail.tsx:39
#: src/auth/pages/userSession/UserSessionEntityPage.tsx:17
msgid "User Session"
msgstr "User Session"

#: src/auth/hooks/useUserSession.ts:65
msgid "User Session add error: "
msgstr "User Session add error: "

#: src/auth/hooks/useUserSession.ts:131
msgid "User Session delete error: "
msgstr "User Session delete error: "

#: src/auth/hooks/useUserSession.ts:128
msgid "User Session deleted"
msgstr "User Session deleted"

#: src/auth/hooks/useUserSession.ts:98
msgid "User Session update error: "
msgstr "User Session update error: "

#: src/auth/hooks/useUserSession.ts:95
msgid "User Session updated"
msgstr "User Session updated"

#: src/app/mappers.tsx:200
#: src/auth/components/user/UserDetail/UserTabs.tsx:50
#: src/auth/components/userSession/UserSessionList/UserSessionListHeader.tsx:44
msgid "User Sessions"
msgstr "User Sessions"

#: src/timber/components/contractorUser/ContractorUserDetail/ContractorUserDetail.tsx:87
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:309
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:215
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx:236
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItem.tsx:433
#: src/timber/components/providerUser/ProviderUserDetail/ProviderUserDetail.tsx:75
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:190
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx:111
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx:202
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItem.tsx:339
msgid "User Type"
msgstr "User Type"

#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserAddForm.tsx:182
#: src/timber/components/contractorUser/ContractorUserForm/ContractorUserUpdateForm.tsx:109
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserAddForm.tsx:123
#: src/timber/components/providerUser/ProviderUserForm/ProviderUserUpdateForm.tsx:65
msgid "User Type is required"
msgstr "User Type is required"

#: src/auth/hooks/useUser.ts:98
msgid "User update error: "
msgstr "User update error: "

#: src/auth/hooks/useUser.ts:95
msgid "User updated"
msgstr "User updated"

#: src/app/mappers.tsx:199
#: src/auth/components/membersGroup/MembersGroupDetail/MembersGroupTabs.tsx:49
#: src/auth/components/user/UserList/UserListHeader.tsx:44
#: src/auth/pages/listItems.tsx:37
msgid "Users"
msgstr "Users"

#: src/timber/components/buyer/BuyerDetail/BuyerDetail.tsx:71
#: src/timber/components/buyer/BuyerForm/BuyerAddForm.tsx:194
#: src/timber/components/buyer/BuyerForm/BuyerUpdateForm.tsx:154
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx:229
#: src/timber/components/buyer/BuyerList/BuyerListItem.tsx:296
#: src/timber/components/contractor/ContractorDetail/ContractorDetail.tsx:71
#: src/timber/components/contractor/ContractorForm/ContractorAddForm.tsx:194
#: src/timber/components/contractor/ContractorForm/ContractorUpdateForm.tsx:154
#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx:229
#: src/timber/components/contractor/ContractorList/ContractorListItem.tsx:289
#: src/timber/components/forestOwner/ForestOwnerDetail/ForestOwnerDetail.tsx:71
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerAddForm.tsx:191
#: src/timber/components/forestOwner/ForestOwnerForm/ForestOwnerUpdateForm.tsx:154
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx:229
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItem.tsx:289
#: src/timber/components/provider/ProviderDetail/ProviderDetail.tsx:71
#: src/timber/components/provider/ProviderForm/ProviderAddForm.tsx:191
#: src/timber/components/provider/ProviderForm/ProviderUpdateForm.tsx:154
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx:229
#: src/timber/components/provider/ProviderList/ProviderListItem.tsx:289
msgid "Vat Id"
msgstr "Vat Id"

#: src/share/components/footer/Copyright.tsx:9
msgid "Version"
msgstr "Version"

#: src/address/components/address/AddressList/AddressListItemTools.tsx:33
#: src/address/components/userAddress/UserAddressList/UserAddressListItemTools.tsx:30
#: src/auth/components/membersGroup/MembersGroupList/MembersGroupListItemTools.tsx:30
#: src/auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItemTools.tsx:30
#: src/auth/components/role/RoleList/RoleListItemTools.tsx:30
#: src/auth/components/roleAssignment/RoleAssignmentList/RoleAssignmentListItemTools.tsx:30
#: src/auth/components/rolePermission/RolePermissionList/RolePermissionListItemTools.tsx:30
#: src/auth/components/scopeGroup/ScopeGroupList/ScopeGroupListItemTools.tsx:30
#: src/auth/components/user/UserList/UserListItemTools.tsx:30
#: src/auth/components/userSession/UserSessionList/UserSessionListItemTools.tsx:30
#: src/location/components/location/LocationList/LocationListItemTools.tsx:33
#: src/timber/components/accountingUser/AccountingUserList/AccountingUserListItemTools.tsx:33
#: src/timber/components/buyer/BuyerList/BuyerListItemTools.tsx:37
#: src/timber/components/buyerUser/BuyerUserList/BuyerUserListItemTools.tsx:37
#: src/timber/components/contractor/ContractorList/ContractorListItemTools.tsx:37
#: src/timber/components/contractorUser/ContractorUserList/ContractorUserListItemTools.tsx:41
#: src/timber/components/cordwood/CordwoodList/CordwoodListItemTools.tsx:33
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItemTools.tsx:33
#: src/timber/components/cutting/CuttingList/CuttingListItemTools.tsx:39
#: src/timber/components/forestOwner/ForestOwnerList/ForestOwnerListItemTools.tsx:33
#: src/timber/components/log/LogList/LogListItemTools.tsx:34
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItemTools.tsx:33
#: src/timber/components/price/PriceList/PriceListItemTools.tsx:33
#: src/timber/components/pricingProfile/PricingProfileList/PricingProfileListItemTools.tsx:33
#: src/timber/components/provider/ProviderList/ProviderListItemTools.tsx:33
#: src/timber/components/providerUser/ProviderUserList/ProviderUserListItemTools.tsx:37
#: src/timber/components/roadCarrier/RoadCarrierList/RoadCarrierListItemTools.tsx:33
#: src/timber/components/shipment/ShipmentList/ShipmentListItemTools.tsx:40
#: src/timber/components/shipmentHistory/ShipmentHistoryList/ShipmentHistoryListItemTools.tsx:33
#: src/timber/components/thicknessClass/ThicknessClassList/ThicknessClassListItemTools.tsx:33
#: src/timber/components/timberClass/TimberClassList/TimberClassListItemTools.tsx:33
#: src/timber/components/timberStorage/TimberStorageList/TimberStorageListItemTools.tsx:41
#: src/timber/components/timberType/TimberTypeList/TimberTypeListItemTools.tsx:33
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItemTools.tsx:33
#: src/timber/types/models/UserType.d.ts:24
msgid "View"
msgstr "View"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:87
#: src/timber/components/cordwood/CordwoodForm/CordwoodAddForm.tsx:307
#: src/timber/components/cordwood/CordwoodForm/CordwoodUpdateForm.tsx:191
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:250
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:563
#: src/timber/components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail.tsx:119
#: src/timber/components/cordwoodHistory/CordwoodHistoryList/CordwoodHistoryListItem.tsx:592
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:422
#: src/timber/components/generic/treeMarkings/ReportTreeMarkings.tsx:472
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:91
#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:124
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:404
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:96
#: src/timber/components/shipment/ShipmentRegulator/LogDetail.tsx:103
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:387
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:99
msgid "Volume"
msgstr "Volume"

#: src/timber/components/shipment/ShipmentRegulator/CordwoodDetail.tsx:159
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingAddForm.tsx:150
#: src/timber/components/treeMarking/TreeMarkingForm/TreeMarkingUpdateForm.tsx:60
msgid "Volume (m&#xB3;)"
msgstr "Volume (m&#xB3;)"

#: src/timber/components/log/LogList/LogListSearch.tsx:454
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx:262
msgid "Volume (m&#xB3;) From"
msgstr "Volume (m&#xB3;) From"

#: src/timber/components/log/LogList/LogListSearch.tsx:464
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListSearch.tsx:272
msgid "Volume (m&#xB3;) To"
msgstr "Volume (m&#xB3;) To"

#: src/timber/components/cordwood/CordwoodDetail/CordwoodDetail.tsx:93
#: src/timber/components/cordwood/CordwoodList/CordwoodListItem.tsx:597
#: src/timber/components/generic/priceCalculator/PriceCalculator.tsx:739
#: src/timber/components/generic/report/GenericRootShipments.tsx:225
#: src/timber/components/generic/report/GenericRootShipments.tsx:431
#: src/timber/components/generic/report/GenericRootTable.tsx:134
#: src/timber/components/log/LogDetail/LogDetail.tsx:96
#: src/timber/components/log/LogList/LogListItem.tsx:257
#: src/timber/components/log/LogList/LogListItem.tsx:655
#: src/timber/components/logHistory/LogHistoryDetail/LogHistoryDetail.tsx:106
#: src/timber/components/logHistory/LogHistoryList/LogHistoryListItem.tsx:537
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:324
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemForShipment.tsx:388
#: src/timber/components/shipment/ShipmentRegulator/CordwoodListItemFromHistory.tsx:90
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:305
#: src/timber/components/shipment/ShipmentRegulator/LogListItemForShipment.tsx:369
#: src/timber/components/shipment/ShipmentRegulator/LogListItemFromHistory.tsx:91
#: src/timber/components/treeMarking/TreeMarkingDetail/TreeMarkingDetail.tsx:84
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx:238
#: src/timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem.tsx:372
msgid "Volume (m³)"
msgstr "Volume (m³)"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:358
msgid "Volume From"
msgstr "Volume From"

#: src/timber/components/cordwood/CordwoodList/CordwoodListSearch.tsx:368
msgid "Volume To"
msgstr "Volume To"

#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:193
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:125
#~ msgid "Warehouse Location Id is required"
#~ msgstr "Warehouse Location Id is required"

#: src/pages/ForgotPasswordPage.tsx:123
msgid "We have sent you a password recovery email."
msgstr "We have sent you a password recovery email."

#: src/pages/PrivacyPolicyPage.tsx:14
msgid "We respect your privacy. This application stores only the data necessary to provide the service and your account access. We do not use non-essential cookies or tracking without your consent."
msgstr "We respect your privacy. This application stores only the data necessary to provide the service and your account access. We do not use non-essential cookies or tracking without your consent."

#: src/share/components/gdpr/CookieConsent.tsx:34
msgid "We use necessary cookies to make this app work. We will not use non-essential cookies without your consent."
msgstr "We use necessary cookies to make this app work. We will not use non-essential cookies without your consent."

#: src/pages/LoginPage.tsx:117
msgid "Welcome Back!"
msgstr "Welcome Back!"

#: src/timber/components/cutting/CuttingDetail/CuttingDetail.tsx:87
#: src/timber/components/cutting/CuttingForm/CuttingAddForm.tsx:269
#: src/timber/components/cutting/CuttingForm/CuttingUpdateForm.tsx:195
#: src/timber/components/shipment/ShipmentDetail/ShipmentDetail.tsx:138
#: src/timber/components/shipment/ShipmentForm/ShipmentAddForm.tsx:652
#: src/timber/components/shipment/ShipmentForm/ShipmentUpdateForm.tsx:447
msgid "Work Order"
msgstr "Work Order"

#: src/share/components/form/FormDateTime/FormDateRange.tsx:209
msgid "Yesterday"
msgstr "Yesterday"

#: src/share/components/gdpr/CookieConsent.tsx:19
msgid "You declined the Terms and Policy. You cannot use the app until you accept them. Reset to start over."
msgstr "You declined the Terms and Policy. You cannot use the app until you accept them. Reset to start over."

#: src/pages/PrivacyPolicyPage.tsx:19
msgid "You may request an export of your personal data or request deletion of your account by visiting your Profile or contacting support."
msgstr "You may request an export of your personal data or request deletion of your account by visiting your Profile or contacting support."

#: src/hooks/useAuth.ts:58
msgid "You successfully logged in"
msgstr "You successfully logged in"
